/* vivid mobileCheck guard (15 Jun): the theme calls window.mobileCheck() inside the
   add-to-cart / confirm click handlers (6 call sites in this file). When it is undefined
   the handler throws ("window.mobileCheck is not a function") and itoris falls back to an
   empty /cart redirect -> the "add to cart says my cart is empty" customer bug. Define it
   up-front so the handlers complete the add. Guarded so it never overrides a real definition. */
window.mobileCheck = window.mobileCheck || function(){
  try{
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent||"")
        || (typeof window.matchMedia==="function" && window.matchMedia("(max-width: 768px)").matches);
  }catch(e){ return false; }
};


window.onbeforeunload = function() {
  var is_modal_show = localStorage.getItem('alreadyShow');
  localStorage.removeItem('alreadyShow');
};
jQuery(document).ready(function($){
   
    $(document).on('keypress', '.input_box.width input', function(e){
    $("#custom_width").val($(this).val());

  });

  $(document).on('keypress', '.input_box.custom-length input', function(e){
    $("#custom_length").val($(this).val());

  });

  $(document).on('keypress', '.input_box.height input', function(e){
    $("#custom_height").val($(this).val());
  
   
});
   // Get the last price value
 var lastPrice = $('.itier_price:last').attr('price');

 // Fallback: Get the metafield price from the data attribute
 var metafieldPrice = $('.price_min').data('metafield-price');

 if (lastPrice && !isNaN(lastPrice)) {
     // Format and round the last price to two decimal places
     var formattedPrice = parseFloat(lastPrice).toFixed(2);
     $('#price_type').text('$' + formattedPrice);
 } else if (metafieldPrice && metafieldPrice !== "0.00") {
     // Use the metafield price if the last price is unavailable
     $('#price_type').text('$' + parseFloat(metafieldPrice).toFixed(2));
 } else {
     // Default fallback if both prices are unavailable
     $('#price_type').text('$0.00');
 }
$('.download__res #gobackto-editor2, #pacdora-design-preview-modal .modal-header .close').click(function(){
  $(".request_quote").trigger("click");  
  $('#pacdora-design-preview-modal').attr('goback','true');
  $('#pacdora-design-preview-modal').modal('hide');
  $('#pacdora-design-preview-modal').removeClass('hide');
  $('#pacdora-design-preview-modal').removeClass('show');
  $("#download_pdf").removeClass("hide");
  $("#modal-addtocart").addClass("hide");
  
  $("#taskId").val('');
  $("#filePath").val('');
  // $("#pp-designs-section").removeClass('hide');


});

$("#download_pdf").click(function(){     
  $("#loading").removeClass('hide');
});


  
  $(".meeting-wrapper").insertBefore("#upload--instructions");
  //$("#getVideo").click(function(){     
    $(document).on('click','#getVideo', function(e){
    $("#getVideoModel").modal('show');
    let video = $("#setup_video").val();
   $("#getVideoModel video source").attr("src",video);
   let media = $("#getVideoModel video").get(0);
   media.play();
   });
 
   $(document).on('click','#close_video', function(e){
   //$("#close_video").click(function(){
    // $("#getVideoModel video").get(0).pause();
    var media = $("#getVideoModel video").get(0);
media.pause();
media.currentTime = 0;
  $("#getVideoModel video source").attr("src",'');

    });

    
   
  $("#close").on('click', function(){
    $("#multiple-designs").hide();

    });

  setTimeout(function(){
    var title=  $("#productSelect option:selected").html();
  
    $('.pitchprint_design img').each(function () {

      var curSrc = $(this).attr('src');
     $(this).attr("data-src",curSrc).addClass("lazy2 lazyload");
     $(this).attr("alt",title);
     $(this).removeAttr("src");
      
    });
    // var img_url = $('.pitchprint_design img').attr('src');
    // $('.pitchprint_design img').attr("data-src",img_url).addClass("lazy2");
  
}, 2000);
    var initProducts = function(domElement) {
    if (domElement.length === 0) {
        return;
    }

    if (domElement.attr('data-use-recommendations') === 'true') {
        var url = '/recommendations/products?section_id=product-recommendations&limit=4&product_id=' + domElement.attr('data-product-id');
        $.ajax(url).then(function(content) {
        domElement.find('.grid').html($(content).find('.grid').contents());
        });
    }
    };

    initProducts($('.product-recommendations'));

    document.addEventListener("shopify:section:load", function(event) {
        initProducts($(event.target).find('.product-recommendations'));
    });
    
    var custom_size_box = $("#hidden_meta_size_custom").val();            
    //   var galleryThumbs = new Swiper('.gallery-thumbs', {
    //     spaceBetween: 10,
    //     slidesPerView: 6,
    // });
  
      $(document).on('click','#star-rating', function(e){
      $("#reviews-tab-btn").trigger('click');
      $("html, body").animate({ scrollTop: $("#reviews").offset().top - 150}, 1000);      
    });
    // var galleryTop = new Swiper('.main-slider', {
    //   loop: true,
    //    navigation: {
    //      nextEl: '.next-wrapper.slider-nav-wrapper',
    //      prevEl: '.prev-wrapper.slider-nav-wrapper',
    //   },
    //   thumbs: {
    //     swiper: galleryThumbs
    //   },
    //   on: {
    //     slideChange: function () {
    //       let activeIndex = this.activeIndex + 1;
        
    //       let activeSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`);
    //       let nextSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`);
    //       let prevSlide = document.querySelector(`.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`);
          
    //       if (nextSlide && !nextSlide.classList.contains('swiper-slide-visible')) {
    //           this.thumbs.swiper.slideNext()	
    //       } else if (prevSlide && !prevSlide.classList.contains('swiper-slide-visible')) {
    //           this.thumbs.swiper.slidePrev()	
    //       }
    
    //     }
    //   }
    // });
   
  $(document).on('click','#edit_design_now_btn', function(e){
      e.preventDefault(true);
      $("#pp_edit_btn").trigger('click');
  })  
  $("#upload_design_now_btn").on('click', function(){
    $(this).addClass('hidden');
    $("#upload_section").removeClass('hide');
    $(".add_to_cartbtn").removeClass('hide');
    $("#pp-designs-section").addClass('hide');
    $("html, body").animate({ scrollTop: $("#upload_section").offset().top }, 1000);    
  });
  
    window.UploadKit = window.UploadKit || {} 
    window.UploadKit.callbacks = window.UploadKit.callbacks || {} 

    window.UploadKit.callbacks.afterFileUploaded = function(data) { 
      // console.log('afterFileUploaded');      
      $('.uploadkit-sketch-image').addClass('hide');
      $('#upload--instructions span:not(.fa)').addClass('hide');
      if($("#require_design_services_hidden").val()=="Let us design one for you"){
          $('.uploadkit-field').addClass('invisible');
      }
       let $activeContainer = $(".active-container #design__upload__single");
      if ($activeContainer.length) {
          let upload_text2 = $activeContainer.text().trim();
          //console.log(upload_text);
          jQuery("#hidden_design_option").val(upload_text2);
      }
       
      
    }
    
    window.UploadKit.callbacks.afterRefresh = function(data) {
      $(document).on('click', '#design_assist', function(){
    
        if(data.uploader.files.length > 0) {
          data.uploader.fileObject = null;
          data.uploader.files = [];
          // console.log(data);
          if (window.UploadKit && typeof UploadKit.refreshUploader === 'function') UploadKit.refreshUploader(data.uploader);
  }

      });
      $(document).on('click', '#design_exist', function(){
        if(data.uploader.files.length > 0) {
          // console.log(data);
          data.uploader.fileObject = null;
          data.uploader.files = [];
          if (window.UploadKit && typeof UploadKit.refreshUploader === 'function') UploadKit.refreshUploader(data.uploader);
  }
   

      });
      if($('.uploadkit-file-listing').length > 0){
        $("#continue_cart").removeClass('hide');
        $("#upload-files-button").addClass('button_gray_active');
      }else{
        $("#continue_cart").addClass('hide');
        $("#upload-files-button").removeClass('button_gray_active');
      }
      $('#continue_cart').closest('.option-content-wrapper').addClass('active-container');
    }


    // $(document).on('click', '.uploadkit-file-listing', function(){
      //   $('.uploadkit-button').trigger('click');
      // })
      $(document).on('click', '.uploadkit-uploader[data-uploader-id="5879b0f9-b4a3-487d-bc3e-ae942ea6a51c"] .uploadkit-file-listing', function(){
        $('.uploadkit-button[data-uploader-id="5879b0f9-b4a3-487d-bc3e-ae942ea6a51c"]').trigger('click');
      });
      $(document).on('click', '.uploadkit-uploader[data-uploader-id="12bc0ec3-44b4-4769-9b50-277bfcddb903"] .uploadkit-file-listing', function(){
        $('.uploadkit-button[data-uploader-id="12bc0ec3-44b4-4769-9b50-277bfcddb903"]').trigger('click');
      });
        let widthSelector = "#standardized_width_"+$('#productSelect').val();
        let widthVal = $(widthSelector).val();            
        if(widthVal!=undefined){
          $("#hidden_property_standardized_width").val(widthVal);
        }
        let widthSelector2 = "#standardized_width_external_"+$('#productSelect').val();
        let widthVal2 = $(widthSelector2).val();            
        if(widthVal2!=undefined){
            $("#hidden_property_standardized_width_external").val(widthVal2);
        }
        let heightSelector = "#standardized_height_"+$('#productSelect').val();
        let heightVal = $(heightSelector).val();            
        if(heightVal!=undefined){
          $("#hidden_property_standardized_height").val(heightVal);
        }
        
        let sidedSelector = "#standardized_sided_"+$('#productSelect').val();
        let sidedVal = $(sidedSelector).val();            
        if(sidedVal!=undefined){
          $("#hidden_property_standardized_sided").val(sidedVal);
        }else{
          $("#hidden_property_standardized_sided").val("Single");
        }
        
        let materialSelector = "#standardized_material_"+$('#productSelect').val();
        let materialVal = $(materialSelector).val();            
        if(materialVal!=undefined){
          $("#hidden_property_standardized_material").val(materialVal);
        }
  
        let rollSizeSelector = "#standardized_roll_size_"+$('#productSelect').val();
        let rollSizeVal = $(rollSizeSelector).val();            
        if(rollSizeVal!=undefined){
          $("#hidden_property_standardized_roll_size").val(rollSizeVal);
        }
    $("#continue_cart").on('click',function(){
   
      if (typeof dpoOptions !== 'undefined') dpoOptions.asyncAddToCartPostCheck = function(){
              //let tmpFrom = $("#form-1");
      //tmpForm.append(jQuery('[name*="properties"]'));
        if (jQuery('#slidecarthq .slidecarthq')[0]) {
     try{
        jQuery.ajax({url: '/cart/update.json', method: 'GET', async: false, dataType: 'json', success: function(cart) {
           window.SLIDECART_SET_CART(cart);
        }}); 
        window.SLIDECART_OPEN();
        setTimeout(function(){
      
       $("#design_exist").trigger("click");
          jQuery('#continue_cart').closest('#upload_section').addClass('hide');
          jQuery('#continue_cart').text('Add To Cart');
          jQuery('#continue_cart').removeAttr('disabled');
          //location.reload();
        }, 3000);
     
     } catch(e){
        window.vividNativeAddSuccess();
     }
        } else {
           window.vividNativeAddSuccess();
        }
     }
      $(this).text('Processing');
      $(this).prop('disabled',true);
      $(this).siblings('svg').attr('class','loading-svg');
      let productWidth = parseInt($('.custom-box.width input').val());
      let productHeight = parseInt($('.custom-box.height input').val());
      // let newWidthValue = $("#hidden_property_standardized_width").val();
      // console.log(productWidth);
      
// Update the value of the input field with the name "properties[_Standardized_Width]"
        $('.comp_standardized_width').val(productWidth);
        $('.comp_standardized_height').val(productHeight);
            let optionValue = $('body').find('.sided-option select option:selected').html();
      // console.log(optionValue);
      if(optionValue!=undefined){
        if(optionValue.includes("Double")||optionValue.includes("Both sides")){
            $('.comp_standardized_sided').val("Double");
                            
        }else{
            $('.comp_standardized_sided').val("Single");
        
        }
    }  
      add_to_cart();
    });
    
    let product1 = null;
  
  
  let coriflute_id = $("#coriflute_id").val();
  $(document).on('click', '#upload-files-button', function(e){
//    if(coriflute_id == 1312616939589){
//      $('.uploadkit-button[data-uploader-id="1cfb0e16-19e3-4d35-86cd-2ef34f15ae39"]').trigger('click');
//  }else {
//    $('.uploadkit-button[data-uploader-id="5879b0f9-b4a3-487d-bc3e-ae942ea6a51c"]').trigger('click');
//  }
$('.uploadkit-button[data-uploader-id="5879b0f9-b4a3-487d-bc3e-ae942ea6a51c"]').trigger('click');

 });

  $(document).on('click', '#upload-final-artwork-button', function(e){
    $('.uploadkit-button[data-uploader-id="12bc0ec3-44b4-4769-9b50-277bfcddb903"]').trigger('click');
  });


  $(document).on('click','.requiredesignstep .option', function(e){
      e.preventDefault(true);    
      $(this).siblings().removeClass('clicked');
     
      $(this).addClass('clicked');
      /* 24-Aug bug #101: default the design-charge property to $0.00 on every choice;
         the design_assist branch below overwrites it with the real fee. (This is the
         hidden_fields.liquid input the order console reads — there is only ONE input
         with this property name; a duplicate serializes last and wins with "$0".) */
      $("#additional_design_charges").val("$0.00");
      $(".optional-workflow-section").removeClass("activesection");
      $(".optional-workflow-section").addClass("hide");
      if($(this).attr('id')=="design_exist"){
        $(".pp-design-btn").addClass("hidden");
               let design_price = $(".price_per_design_dpo .exist input").attr("price") || "0";
$("#additional_design_charges").val("$" + design_price);
        $(".design__upload").parent().removeClass("hide");
        //$("#total-elementor .receipt h2").parent().parent().removeClass("hide");
        $(".w-100-files").parent().parent().addClass("col-md-6").removeClass("col-md-12");
       // $(".quote_btn .confirm_order").find("span").text("Add To Cart");
           // console.log('exist');
           $(".quote_btn .confirm_order").removeAttr("id");
           $(".multiple").addClass('hidden'); 
           $("#pp-designs-section").css("display","none");
           $(".meeting-wrapper").addClass('hidden');   
           $(".meeting-button-wrapper").addClass("hidden");
         // $("#require_design_services_hidden").val("Upload a finished artwork");
         let design_charges_html = $("#design_exist b").text();
          // console.log(design_charges_html);
          $("#require_design_services_hidden").val(design_charges_html);
          $("#pitchprint_custom_design").val("exist");    
          $("#upload_section").addClass('activesection'); 
          $("#continue_cart").addClass("hide");
          jQuery('#skip_upload').removeClass("hide");
          if($('.view_pp_templates').hasClass('clicked')){
            $("#total-elementor").removeClass('hidden');
              $("#upload_section").addClass('hide'); 
              //$(this).find("span").text("Calculate Price");
          }
          $('body').removeClass('design_assist');
          $('body').removeClass('design_own_option');
          $('body').addClass('design_exist');
           $(".quote_btn .confirm_order").text("Next");
          if ($('body').hasClass('design_exist')) {
            $("#upload_now_container").removeClass("active-container");
              $("#upload--instructions").addClass('active-container');
            setTimeout(function(){
            $('.but-flex-layout .but-column #skip_upload').removeClass("hide");
         
            
          }, 800);
        }
          $(".design__upload").removeClass('hidden');
            $('.design__assist').addClass('hidden');
            $("#upload-files-button").removeClass('hidden');
            $("#upload-final-artwork-button").addClass("hidden");
          if($('.uploadkit-thumbnails').children().length>0){              
              $("#continue_cart").removeClass("hide");
          }else{
              $("#continue_cart").addClass("hide");
              $(".uploadkit-sketch-image").removeClass('hide');              
          }
          $('.dpo_meeting_option .no input').prop('checked',true);
          $('.dpo_meeting_option .no input').trigger('change');
          $("#numberofdesignsdropdown").prop('disabled',false);
          $('.price_per_design_dpo .exist input').prop('checked', true);
          $('.price_per_design_dpo .exist input').trigger('change');
          if(!isNaN(parseInt($('#numberofdesignsdropdown').val()))){
              $('.price_per_design_dpo .exist input[type="number"]').val($('#numberofdesignsdropdown').val());
          }else{
              $('.price_per_design_dpo .exist input[type="number"]').val(1);
          }
          $('.uploadkit-field').removeClass('invisible');
          if($(".quantity__input").val()>1){
              $(".numberofdesignstep").removeClass('invisible');
          }        
          $('.booking-section').addClass('hide');
      }else if($(this).attr('id')=="design_own_option"){
        $('.ppclient-change-option select').trigger('change');
        // console.log("sss");
        //$("#total-elementor .receipt h2").parent().parent().addClass("hide");
          // console.log('own');
          $("#continue_cart").addClass("hide");
          $('body').removeClass('design_assist');
          $('body').addClass('design_own_option');
          $('body').removeClass('design_exist');
          if ($('body').hasClass('design_own_option')) {
            setTimeout(function(){
              //$("#own_template span").text("Start Designing");

            $('.but-flex-layout .but-column #continue_cart').addClass("hide");
         
            
          }, 4000);
        }
          $(".design__upload").parent().addClass("hide");
          $("#pp-designs-section").css("display","none");
          $(".pp-design-btn").removeClass("hidden");
          $(".quote_btn .confirm_order").attr("id", "own_template").text("Start Designing");
            //$("#own_template").find("span").text("Start Designing");
          let design_charges_html = $("#design_own_option b").text();
            // console.log(design_charges_html);
            $("#require_design_services_hidden").val(design_charges_html);
       // $("#require_design_services_hidden").val("Online design from templates");
        $("#pitchprint_custom_design").val("true");  
        $(".w-100-files").parent().parent().addClass("col-md-6").removeClass("col-md-12");
        $("#pp-designs-section").addClass('activesection');
          if($('.view_pp_templates').hasClass('clicked')){
              $("#pp-designs-section").removeClass('hide'); 
          }
          $('.dpo_meeting_option .no input').prop('checked',true);
          $('.dpo_meeting_option .no input').trigger('change');          
          $("#numberofdesignsdropdown").val(1);
          $("#numberofdesignsdropdown").prop('disabled',true);
          $('.price_per_design_dpo .own input').prop('checked', true);
          $('.price_per_design_dpo .own input').trigger('change');
          if(!isNaN(parseInt($('#numberofdesignsdropdown').val()))){
              $('.price_per_design_dpo .own input[type="number"]').val($('#numberofdesignsdropdown').val());
          }else{
              $('.price_per_design_dpo .own input[type="number"]').val(1);
          }
          $(".numberofdesignstep").addClass('invisible');
      }else if($(this).attr('id')=="design_assist"){ 
        $('button[onclick*="dpoOptions"]').each(function() {
          this.style.setProperty('display', 'none', 'important');
        });
      
         
        //let design_price = $(".price_per_design_dpo .assist input").attr('price');
       let design_price = $(".price_per_design_dpo .assist input").attr("price") || "0";
        $("#additional_design_charges").val("$" + design_price);
        /* 24-Aug bug #101: on native products the DPO input above does not exist and
           design_price is "0". The real fee is server-rendered into #design_charges_dpo
           (data-vv-fee). Stamp it into the form property the order console reads. */
        if (typeof window.dpoOptions === 'undefined') {
          $("#additional_design_charges").val("$" + (window.vvDesignFee ? window.vvDesignFee() : 0).toFixed(2));
        }
        $(".pp-design-btn").addClass("hidden");
        $(".design__upload").parent().removeClass("hide");
        $('body').addClass('design_assist');
          $('body').removeClass('design_own_option');
          $('body').removeClass('design_exist');
           $(".quote_btn .confirm_order").text("Next");
        if ($('body').hasClass('design_assist')) {
           
          setTimeout(function(){
            $("#upload_now_container").removeClass("active-container");
            $('.but-flex-layout .but-column #skip_upload').addClass("hide");
            
          $('.but-flex-layout .but-column #continue_cart').removeClass("hide");
       
          
        }, 800);
        $('button[onclick*="dpoOptions"]').each(function() {
          this.style.setProperty('display', 'block', 'important');
        });
      
         
      }
        
        $("#continue_cart").removeClass("hide");
        jQuery('#skip_upload').addClass("hide");
        //$("#total-elementor .receipt h2").parent().parent().removeClass("hide");
        $(".multiple").removeClass('hidden');
        $("#pp-designs-section").css("display","none");   
        //$(".quote_btn .confirm_order").find("span").text("Add To Cart");
        $(".w-100-files").parent().parent().addClass("col-md-12").removeClass("col-md-6");
        $(".quote_btn .confirm_order").removeAttr("id");
        $(".meeting-wrapper").addClass('hidden');   
        $(".meeting-button-wrapper").removeClass("hidden");
        $(".design__upload").addClass('hidden');
       $("#upload-files-button").addClass('hidden');
        $('.design__assist').removeClass('hidden');
        $('#upload-final-artwork-button').removeClass('hidden');
          let design_charges_html = $("#design_assist b").text();
        // console.log(design_charges_html);
        $("#require_design_services_hidden").val(design_charges_html);
        //$("#require_design_services_hidden").val("Let us design one for you");
        $("#pitchprint_custom_design").val("false");
        
        $(".uploadkit-sketch-image").addClass('hide');
        $(".design__idea").removeClass('hide');
        $("#upload_section").addClass('activesection');
        if($('.view_pp_templates').hasClass('clicked')){
         $("#continue_cart").removeClass("hide");
            $("#upload_section").removeClass('hide'); 
        }
        if($('#design-idea-textarea').val()!=""){
            $("#upload--instructions span").addClass('hide');
           
            $("#continue_cart").removeClass("hide");
            $("#numberofdesignsdropdown").prop('disabled',false);
        }else{
            $("#numberofdesignsdropdown").prop('disabled',false);
            $("#continue_cart").addClass("hide");
            $("#upload--instructions span").removeClass('hide');
        }
        $('.dpo_meeting_option .yes input').prop('checked',true);
        $('.dpo_meeting_option .yes input').trigger('change');

        $('.uploadkit-field').addClass('invisible');
        $('.price_per_design_dpo .assist input').prop('checked', true);
        $('.price_per_design_dpo .assist input').trigger('change');
        if(!isNaN(parseInt($('#numberofdesignsdropdown').val()))){
            $('.price_per_design_dpo .assist input[type="number"]').val($('#numberofdesignsdropdown').val());
        }else{
            $('.price_per_design_dpo .assist input[type="number"]').val(1);
        }

        if($(".quantity__input").val()>1){
            $(".numberofdesignstep").removeClass('invisible');
        } 
        $('.booking-section').removeClass('hide');       
      }else{
        $("#require_design_services_hidden").val($(this).text());
      }       
  
      $('.view_pp_templates').removeClass('disabled');
      $('.view_pp_templates').removeClass('hide');
      $('.view_pp_templates').addClass('initialized');
    
      if(e.originalEvent !==undefined){            
          createDraftOrder();   
      }
      
    });
    
  
    window.__vividAdding = window.__vividAdding || false;
    window.__vividAddSnapshot = null;
    window.__vividAddHandled = false;
    window.vividReleaseAddLock = function(){ try{ window.__vividAdding=false; clearTimeout(window.__vividAddTimer); }catch(e){} };
    window.vividCartGet = function(cb){ try{ fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){ cb(c); }).catch(function(){ cb(null); }); }catch(e){ cb(null); } };
    window.vividDisableCompetingAddButtons = function(d){ try{ document.querySelectorAll('#continue_cart,#skip_upload,.confirm_order,.add_to_cartbtn,[onclick*="dpoOptions"],.product-form__submit,.continue--btn').forEach(function(b){ if(d){ b.setAttribute('aria-disabled','true'); b.classList.add('vivid-adding'); } else { b.removeAttribute('aria-disabled'); b.classList.remove('vivid-adding'); } }); }catch(e){} };
    window.vividUpdateBubbleOnly = function(){ try{ var base=window.location.pathname.split('?')[0]; fetch(base+'?sections=cart-icon-bubble',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(s){ var el=document.getElementById('cart-icon-bubble'); if(el && s['cart-icon-bubble']){ try{ el.innerHTML=new DOMParser().parseFromString(s['cart-icon-bubble'],'text/html').querySelector('.shopify-section').innerHTML; }catch(e){} } }); }catch(e){} };
    window.vividSetAddButtonState = function(state){ try{ var btns=document.querySelectorAll('#continue_cart,#skip_upload,.confirm_order,.add_to_cartbtn'); if(state==='adding'){ btns.forEach(function(b){ b.classList.add('vivid-adding'); }); } else if(state==='success'){ btns.forEach(function(b){ b.classList.remove('vivid-adding'); try{ jQuery(b).text('Added ✓'); }catch(e){} }); setTimeout(function(){ try{ jQuery('#continue_cart,#skip_upload,.confirm_order,.add_to_cartbtn').text('Add To Cart').removeAttr('disabled').prop('disabled',false); jQuery('#continue_cart, #skip_upload').closest('#upload_section').addClass('hide'); }catch(e){} }, 2200); } else if(state==='error'){ btns.forEach(function(b){ b.classList.remove('vivid-adding'); try{ jQuery(b).text('Add To Cart').removeAttr('disabled').prop('disabled',false); }catch(e){} }); window.vividShowAddError(); } }catch(e){} };
    window.vividShowAddError = function(){ try{ var box=document.getElementById('vivid-add-error'); if(!box){ box=document.createElement('div'); box.id='vivid-add-error'; box.setAttribute('role','alert'); box.style.cssText='margin:10px 0;padding:10px 14px;border:1px solid #e5413f;border-radius:6px;background:#fff4f4;color:#b00020;font-size:14px;font-weight:600;'; box.innerHTML='We couldn’t confirm this was added. <a href="/cart" style="color:#b00020;text-decoration:underline;">View cart</a> or try again.'; var anchor=document.querySelector('#continue_cart, #skip_upload, .confirm_order'); if(anchor && anchor.parentNode){ anchor.parentNode.insertBefore(box, anchor); } else { document.body.appendChild(box); } } box.style.display='block'; try{ jQuery('.continue--btn').removeClass('hide').show(); }catch(e){} }catch(e){} };
    window.vividClearAddError = function(){ try{ var b=document.getElementById('vivid-add-error'); if(b) b.style.display='none'; }catch(e){} };
    window.vividRenderCartNotification = function(cart){ try{ var nEl=document.getElementById('cart-notification'); if(!nEl || !cart || !cart.items || !cart.items.length){ return; } var lastKey=cart.items[cart.items.length-1].key; var secs=[{id:"cart-notification-product", selector:'[id="cart-notification-product-'+lastKey+'"]'},{id:"cart-notification-button", selector:".shopify-section"},{id:"cart-icon-bubble", selector:".shopify-section"}]; fetch(window.location.pathname.split('?')[0]+'?sections=cart-notification-product,cart-notification-button,cart-icon-bubble',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(sections){ secs.forEach(function(sec){ try{ var el=document.getElementById(sec.id); var h=sections[sec.id]; if(el&&h){ var d=new DOMParser().parseFromString(h,'text/html'); var pk=d.querySelector(sec.selector); if(pk){ el.innerHTML=pk.innerHTML; } } }catch(e){} }); try{ nEl.classList.add("animate","active"); document.body.addEventListener("click", function _v(ev){ if(!ev.target.closest("cart-notification")){ nEl.classList.remove("active"); document.body.removeEventListener("click", _v); } }); }catch(e){} }).catch(function(){}); }catch(e){} };
    window.vividFireAddToCartAnalytics = function(cart){ try{ var item=(cart.items&&cart.items.length)?cart.items[cart.items.length-1]:null; var value=item?(item.final_line_price/100):((cart.total_price||0)/100); var ga={currency:'AUD', value:value, items: item?[{item_id:String(item.product_id), item_name:item.product_title, price:(item.final_price/100), quantity:item.quantity}]:[]}; try{ if(typeof window.gtag==='function'){ window.gtag('event','add_to_cart', ga); } }catch(e){} try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push({event:'add_to_cart', source:'vivid-dpo', ecommerce: ga}); }catch(e){} try{ if(typeof window.clarity==='function'){ window.clarity('event','configured_add_to_cart'); } }catch(e){} }catch(e){} };
    window.vividVerifyCart = function(cart){ try{ var item=(cart.items&&cart.items.length)?cart.items[cart.items.length-1]:null; var keys=item&&item.properties?Object.keys(item.properties):[]; var hasDpo=keys.some(function(k){ return /_Bubble_|Price per design|Digital Proof|_Material|_Shape|_Standardized/.test(k); }); var sigs={}, dupes=0; (cart.items||[]).forEach(function(it){ var sg=it.variant_id+'|'+JSON.stringify(it.properties||{}); sigs[sg]=(sigs[sg]||0)+1; if(sigs[sg]>1) dupes++; }); var v={ ok: !!(item && item.final_price>0 && hasDpo && dupes===0), lastItem: item?item.product_title:null, price: item?item.final_price/100:null, qty: item?item.quantity:null, dpoMetadataPresent:hasDpo, propertyKeys:keys.slice(0,14), itemCount:cart.item_count, duplicateLineItems:dupes }; window.__vividLastAddVerify=v; try{ console.log('[vivid ATC verify]', v); }catch(e){} return v; }catch(e){ return null; } };
    window.vividOnAddConfirmed = function(cart){ if(window.__vividAddHandled) return; window.__vividAddHandled=true; try{ clearInterval(window.__vividAddPoll); }catch(e){} try{ window.vividClearAddError(); }catch(e){} try{ window.vividUpdateBubbleOnly(); }catch(e){} try{ window.vividRenderCartNotification(cart); }catch(e){} try{ window.vividFireAddToCartAnalytics(cart); }catch(e){} try{ window.vividVerifyCart(cart); }catch(e){} try{ window.vividSetAddButtonState('success'); }catch(e){} try{ window.vividDisableCompetingAddButtons(false); }catch(e){} window.vividReleaseAddLock(); };
    window.vividConfirmAdd = function(){ if(window.__vividAddHandled) return; window.vividCartGet(function(cart){ if(!cart || window.__vividAddHandled) return; var snap=(window.__vividAddSnapshot==null)?0:window.__vividAddSnapshot; if(cart.item_count > snap){ window.vividOnAddConfirmed(cart); } }); };
    window.vividStartAddWatch = function(){ window.__vividAddHandled=false; window.__vividAddSnapshot=null; try{ window.vividClearAddError(); }catch(e){} try{ var b=document.querySelector('#cart-icon-bubble'); if(b){ var m=(b.textContent||'').match(/\((\d+)\)/); if(m){ window.__vividAddSnapshot=parseInt(m[1],10); } } }catch(e){} window.vividCartGet(function(c){ if(window.__vividAddSnapshot==null && c){ window.__vividAddSnapshot=c.item_count; } }); try{ clearInterval(window.__vividAddPoll); }catch(e){} var tries=0; window.__vividAddPoll=setInterval(function(){ tries++; window.vividConfirmAdd(); if(window.__vividAddHandled || tries>30){ try{ clearInterval(window.__vividAddPoll); }catch(e){} if(!window.__vividAddHandled){ try{ window.vividSetAddButtonState('error'); }catch(e){} window.vividReleaseAddLock(); } } }, 700); };
    /* Back-compat: itoris asyncAddToCartPostCheck + the fallback branch call vividNativeAddSuccess; route it through the idempotent confirmed-add check (accelerator, never the /cart redirect). */
    window.vividNativeAddSuccess = function(){ try{ window.vividConfirmAdd(); }catch(e){} };
    if(!document.getElementById('vivid-atc-style')){ try{ var st=document.createElement('style'); st.id='vivid-atc-style'; st.textContent='.vivid-adding{pointer-events:none !important;opacity:.65 !important;}'; document.head.appendChild(st); }catch(e){} }
    /* 24-Aug bug #101 (Joshua, urgent): "Expert designer" stopped charging on 21 Aug when
       the theme stopped loading ITORIS DPO on native buy-flow products — the fee rode on a
       DPO option that no longer renders. ~47 orders at $99 and several at $199 in the prior
       fortnight; zero since. On the native path the fee is charged as its own line from the
       hidden "Professional Design Service" product, qty = number of designs, and the main
       line still carries _Additional Design Charges (the console's contract, unchanged).
       When window.dpoOptions exists ITORIS still charges it itself — do nothing then. */
    window.vvDesignFee = function(){
      var el=document.getElementById('design_charges_dpo');
      if(!el) return 0;
      var f=parseFloat(el.getAttribute('data-vv-fee')||el.textContent);
      return isFinite(f)&&f>0?f:0;
    };
    var VV_FEE_VARIANTS={99:45593650987077,199:45593651085381};
    function vvAddDesignFee(done){
      done=done||function(){};
      try{
        if(typeof window.dpoOptions!=='undefined'){ done(); return; }      // ITORIS owns the fee
        if(!jQuery('body').hasClass('design_assist')){ done(); return; }   // no design service chosen
        var fee=window.vvDesignFee();
        var vid=VV_FEE_VARIANTS[fee];
        if(!fee||!vid){ done(); return; }                                  // unknown amount: never guess a charge
        var n=parseInt(jQuery('#numberofdesignsdropdown').val(),10); if(isNaN(n)||n<1){ n=1; }
        var props={ id:vid, quantity:n };
        props['properties[_Design fee for]']=(jQuery('#hidden_product_title').val()||document.title).trim();
        props['properties[_Additional Design Charges]']='$'+fee.toFixed(2);
        jQuery.ajax({type:'POST',url:'/cart/add.js',dataType:'json',data:props,
          complete:function(){ done(); }});                                // fee failure never blocks the main add
      }catch(e){ done(); }
    }
    function add_to_cart(){
      if(window.__vividAdding){ return false; }
      window.__vividAdding=true;
      window.__vividAddHandled=false;
      try{ window.vividDisableCompetingAddButtons(true); window.vividSetAddButtonState('adding'); }catch(e){}
      try{ window.vividStartAddWatch(); }catch(e){}
      try{ clearTimeout(window.__vividAddTimer); }catch(e){}
      window.__vividAddTimer=setTimeout(function(){ window.vividReleaseAddLock(); try{window.vividDisableCompetingAddButtons(false);}catch(e){} }, 25000);
      if(typeof window.dpoOptions != 'undefined'){
        window.dpoOptions.addToCart(this, event);         
        
      }else if(typeof window.tpObserver !='undefined'){
        window.tpObserver.addToCart(event);
        vvAddDesignFee();   // tpObserver's add is fire-and-forget; the fee line rides alongside
       
      }else{
        $.ajax({
          
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: $('#AddToCartForm').serialize(),
                success: function(){
                  vvAddDesignFee(function(){
                  // Vivid Ads CRO: open the SlideCart drawer (matches live UX) instead of redirecting to /cart.
                  try{
                    if(typeof window.SLIDECART_OPEN === 'function'){
                      if(typeof window.SLIDECART_SET_CART === 'function'){
                        $.ajax({url:'/cart.js', method:'GET', dataType:'json',
                          success:function(c){ try{ window.SLIDECART_SET_CART(c); }catch(e){} window.SLIDECART_OPEN(); },
                          error:function(){ window.SLIDECART_OPEN(); }});
                      } else { window.SLIDECART_OPEN(); }
                      return;
                    }
                  }catch(e){}
                  // Last resort only if the SlideCart drawer is unavailable:
                  window.vividNativeAddSuccess();
                  });   // close vvAddDesignFee — the fee line is in before the drawer opens
                },
                error: function(){
                     window.vividReleaseAddLock(); alert('Sorry, something went wrong. Please try again'); 
                }
              });
      }
    }
    
    $(document).on('click','#getQuote', function(e){
 //   $("#getQuote").click(function(){     
      $("#getQuoteForm").modal('show');
    
        $(".modal-header h3").html("Email me a quote");
        $(".thankyou-message").addClass("hide");
        $(".form-first").removeClass("hide");
        $("#get_quote_form_btn").removeClass("hide");
        $("#quote_to_cart_btn").addClass("hide");
    });
  
    $("#skip_upload").on('click', function(e){  
   


        if (typeof dpoOptions !== 'undefined') dpoOptions.asyncAddToCartPostCheck = function(){
        if (jQuery('#slidecarthq .slidecarthq')[0]) {
     try{
        jQuery.ajax({url: '/cart/update.json', method: 'GET', async: false, dataType: 'json', success: function(cart) {
           window.SLIDECART_SET_CART(cart);
        }}); 
        window.SLIDECART_OPEN();
        setTimeout(function(){
       $("#design_exist").trigger("click");
          jQuery('#skip_upload').closest('#upload_section').addClass('hide');
          jQuery('#skip_upload').text('Add To Cart');
          jQuery('#skip_upload').removeAttr('disabled');
       
         // location.reload();
        }, 4000);
     
     } catch(e){
        window.vividNativeAddSuccess();
     }
        } else {
           window.vividNativeAddSuccess();
        }
     }
      // console.log($(this));
      $(this).text("Processing");  
 
      let productWidth = parseInt($('.custom-box.width input').val());
      let productHeight = parseInt($('.custom-box.height input').val());
        $('.comp_standardized_width').val(productWidth);
        $('.comp_standardized_height').val(productHeight);
           let optionValue = $('body').find('.sided-option select option:selected').html();
 
      if(optionValue!=undefined){
        if(optionValue.includes("Double")||optionValue.includes("Both sides")){
            $('.comp_standardized_sided').val("Double");
                            
        }else{
            $('.comp_standardized_sided').val("Single");
        
        }
    }  

    
      add_to_cart();
    
    });
 $(document).on('change', '.select-product-option select', function(e){
     let selectedOption = $(this).find('option:selected').html() || '';
      if(selectedOption.includes('Yes')){
     $("#upload--instructions").addClass('hidden');
      }else{
        $("#upload--instructions").removeClass('hidden');
      }
    });
  
    // Number of designs dropdown change event
    $(document).on('change', '#numberofdesignsdropdown', function(e){
      e.preventDefault(true);
  
      //update hidden_no_design input field
      $(".hidden_no_design input").val($(this).val());
      $(".hidden_no_design input").prop('checked', true);
      $('.hidden_no_design select>option').attr('selected', false);
      $('.hidden_no_design select').val($('.hidden_no_design select>option:eq('+$(this).val()+')').attr("value"));
      $('.hidden_no_design select>option:eq('+$(this).val()+')').attr('selected', true);
  
      if($(this).val()>=1){
          $('.price_per_design_dpo input[type="number"]').val($(this).val());
      }    
      window.dpoOptions.updatePrice();
    });
  
    $(document).on('change', '.hidden_no_design select', function(){
      // console.log('hidden no design trigger change');       
    });
  
    $("#BackToTop").click(function (e) {
      $("html, body").animate({ scrollTop: $("#step_1").offset().top }, 1000);
      return true;
    });
    
    function disableAllFields(){
      $('.requiredesignstep .option, #itoris_dynamicproductoptions div.control').addClass('disabled');
      $("#numberofdesignsdropdown,.quantity__input, .single-option-selector").prop('disabled', true);    
      $("#quote-first-message").addClass('hide');
  }
  
  function enableAllFields(){
      $("#quote-first-message").addClass('hide');
      $('.requiredesignstep .option, #itoris_dynamicproductoptions div.control').removeClass('disabled');
      $("#numberofdesignsdropdown,.quantity__input,.single-option-selector").removeAttr('disabled');    
  }
    $("#quote_to_cart_btn").click(function(){
      $("#getQuoteForm").modal('hide');
      return add_to_cart();
    });
  
  
  
  $(document).on('change', 'select, input[type="text"],input[type="radio"], input[type="number"]', function(event){
      if(event.originalEvent !== undefined){
          createDraftOrder();
      }    
  });
    
    let customeremail = '';
   
  $(document).on('change', '.popular select', function(e){
    
      let selectedOption = $(this).find('option:selected').html() || '';
      if(!selectedOption.includes('Custom')){
          $('.width').addClass('hide');
          $('.height').addClass('hide');
          $('.sqm-total').addClass('hide');
          $("#design_own_option").removeClass('hide');
      }else{
          $('.width').removeClass('hide');
          $('.height').removeClass('hide');
          $('.sqm-total').removeClass('hide');
          $("#design_own_option").addClass('hide');
      }
  })
  $(document).on('keyup', '.custom-box.width, .custom-box.height', function(e){
      //if($("#require_design_services_hidden").val()=="Online design from templates"){
    if($("#require_design_services_hidden").val()=="Design tool"){
          if(window.ppclient!=undefined){
              let productWidth = parseInt($('.custom-box.width input').val());
              let productHeight = parseInt($('.custom-box.height input').val());
              window.ppclient.fire('resize-page', { width: productWidth, height: productHeight}); 
          }
      }
    
      if($('#hidden_width_increasement').val()!=undefined){
        $('#hidden_property_standardized_width').val(parseInt($('.custom-box.width input').val()) + parseInt($('#hidden_width_increasement').val()));
      }else{
        $('#hidden_property_standardized_width').val(parseInt($('.custom-box.width input').val()));
      }  	
      if($('#hidden_height_increasement').val()!=undefined){
          $('#hidden_property_standardized_height').val(parseInt($('.custom-box.height input').val()) + parseInt($('#hidden_height_increasement').val()));
      }else{
        $('#hidden_property_standardized_height').val(parseInt($('.custom-box.height input').val()));
      }
  })
  $(document).on('change', ".ppclient-change-option select", function(e){
     
    if($(this).find('option:selected').is('[class*="pp-cat"]')){
        var classes = $(this).find('option:selected').attr('class');
        let classesArray = classes.split(" ");
        classesArray = classesArray.filter(function(d){return d.includes('pp-cat')});
        let catId = classesArray[0].substr(7);
        $("#pp_design_cat_hidden_id").val(catId);    
        getPPDesignPreviewImages();
      }    
  });
  
  $(document).on('change', ".eyelets-option select", function(e){
    let selectedEyelets = $(this).find('option:selected').html() || '';
    $('#hidden_property_standardized_eyelets').val(selectedEyelets);   
  });
    
  $(document).on('click','.optional-workflow-section-close', function(e){
    $(this).closest('.optional-workflow-section').addClass('hide');
  })

 
 
  function getPPDesignPreviewImages(catId){
    if($("#hidden_meta_print_read_artwork_options").val().indexOf('own')!=-1){
      
      // console.log('getPPDesignPreviewImages')
      if(catId==undefined){
          catId = $("#pp_design_cat_hidden_id").val();
      }            
      if(catId.includes('pp-cat-')){
      catId = catId.substr(7);
      }             
      let data = {
          "category_id":catId
      };  
      $(".pp-designs-wrapper .items").html("");
      $('.pp-designs-wrapper .pager .pageNumbers').html("");
          
      $.ajax({
          method: "POST",  
          url: "https://phpstack-321644-985620.cloudwaysapps.com/pitchprint-design.php", 
          data: data,
  
          success: function(result){                                       
              let data = JSON.parse(result);
              let designs = data.data.items;            
            
              designs.sort(function (a, b) {
                  return a.title.localeCompare(b.title);
              });
  
            // console.log('designs:',designs.length);
            
              (function(_o){var _n=0;(function _g(){var _$=window.jQuery;if(_$&&_$.fn&&typeof _$.fn.pagination==='function'){try{_$(".pp-designs-wrapper").pagination(_o);}catch(e){}}else if(_n++<60){setTimeout(_g,100);}})();})({
                  dataSource: designs,
                  pageSize: 3,
                  callback: function(data, pagination) {    
                    var title=  $("#productSelect option:selected").html();              
                      var html = data;
                      $('.pp-designs-wrapper .items').html(html);
                      data.forEach(function(d){
                          let previewImg = d.previews[0];
                          $(".pp-designs-wrapper .items").append('<div class="pitchprint_design" design-id="'+d.id+'"><div class="pp-design-overlay"></div><img class="lazy2 lazyload" data-src="'+previewImg+'" alt="'+title+'"/><a href="javascript:void(0)" class="customize_design">Customise</a></div>');
                      })                        
                  }
              });
              // console.log('pagina again');
              // $("img.lazyload").lazyload();
          }
  
      });  
    }else{
      // console.log('getPPDesignPreviewImages no own');
    }    


   
        }
  $(document).on('change', ".size-option select", function(e){
    if($(this).find('option:selected').is('[class*="pp-cat"]')){
      var classes = $(this).find('option:selected').attr('class');
        let classesArray = classes.split(" ");
        classesArray = classesArray.filter(function(d){return d.includes('pp-cat')});
        let catId = classesArray[0].substr(7);
        // console.log(catId);
        $("#pp_design_cat_hidden_id").val(catId);      
        getPPDesignPreviewImages();
    }
    let optHtml = $(this).find('option:selected').html() || '';
    if(optHtml !== "Custom"){
  let sizeArray = optHtml.split('x');
  if(sizeArray.length>1){
          if($('#hidden_width_increasement').val()!=undefined){
            $('#hidden_property_standardized_width').val(parseInt(sizeArray[0])+parseInt($('#hidden_width_increasement').val()));
          }else{
            $('#hidden_property_standardized_width').val(parseInt(sizeArray[0]));
          }
          if($('#hidden_height_increasement').val()!=undefined){
            $('#hidden_property_standardized_height').val(parseInt(sizeArray[1])+parseInt($('#hidden_height_increasement').val())); 
          }else{
            $('#hidden_property_standardized_height').val(parseInt(sizeArray[1])); 
          }          
        }  
}
    // if($(this).find('option:selected').html()!="Custom"){
    //     let sizeArray = $(this).find('option:selected').html().split('x');
    //     if(sizeArray.length>1){
    //       if($('#hidden_width_increasement').val()!=undefined){
    //         $('#hidden_property_standardized_width').val(parseInt(sizeArray[0])+parseInt($('#hidden_width_increasement').val()));
    //       }else{
    //         $('#hidden_property_standardized_width').val(parseInt(sizeArray[0]));
    //       }
    //       if($('#hidden_height_increasement').val()!=undefined){
    //         $('#hidden_property_standardized_height').val(parseInt(sizeArray[1])+parseInt($('#hidden_height_increasement').val())); 
    //       }else{
    //         $('#hidden_property_standardized_height').val(parseInt(sizeArray[1])); 
    //       }          
    //     }      	
    // }
  });

  
    $(document).on('change', ".choose-thickness select", function(e){
        let optionValue = $(this).find('option:selected').html();
        
        // console.log(optionValue=='3mm');
       if(optionValue!=undefined){
         if(optionValue=='3mm'){
              $('#hidden_property_standardized_thickness').val("3mm");
           $('.comp_standardized_thickness').val("3mm");
          }else{
              $('#hidden_property_standardized_thickness').val("5mm");
             $('.comp_standardized_thickness').val("5mm");
          }
      }  
    });

  
  // $(document).on('change', ".sided-option select", function(e){
  //     let optionValue = $(this).find('option:selected').html();
      
  //     if(optionValue!=undefined){
  //         if(optionValue.includes("Double") || optionValue.includes("Both sides")){
  //         $('#printing_pages').val("2");
  //         $('#hidden_property_standardized_sided').val("Double");
  //             if($('#hidden_variant_size').val()!=""){
  //                 let sizeObj = JSON.parse($('#hidden_variant_size').val());
  //                 if('double' in sizeObj){
  //                     $('#hidden_property_standardized_width').val(sizeObj.double.width);
  //                     $('#hidden_property_standardized_height').val(sizeObj.double.height);
  //                 }                
  //             }
  //         }else{
             
  //              $('#printing_pages').val("1");
  //              $('#hidden_property_standardized_sided').val("Single");
  //             if($('#hidden_variant_size').val()!=""){
  //                 let sizeObj = JSON.parse($('#hidden_variant_size').val());
  //                 if('single' in sizeObj){
  //                     $('#hidden_property_standardized_width').val(sizeObj.single.width);
  //                     $('#hidden_property_standardized_height').val(sizeObj.single.height);
  //                 }                
  //             }
  //         }
  //     }  
  // });
    
  let isLocked = false; // Lock to prevent unwanted changes

  // Handle changes in the select
  $(document).on('change', ".sided-option select", function () {
      let optionValue = $(this).find('option:selected').html()?.trim();
     // console.log('Selected Option Value:', optionValue);
  
      if (optionValue && (optionValue.includes("Double") || optionValue.includes("Both sides"))) {
         // console.log('Setting to Double');
          isLocked = true; // Lock changes
          $('#hidden_property_standardized_sided').val("Double").trigger('change');
          $('#printing_pages').val("2");
  
          if ($('#hidden_variant_size').val()) {
              let sizeObj = JSON.parse($('#hidden_variant_size').val());
              if ('double' in sizeObj) {
                  $('#hidden_property_standardized_width').val(sizeObj.double.width);
                  $('#hidden_property_standardized_height').val(sizeObj.double.height);
              }
          }
      } else {
          // console.log('Setting to Single');
          isLocked = false; // Unlock changes
          $('#hidden_property_standardized_sided').val("Single").trigger('change');
          $('#printing_pages').val("1");
  
          if ($('#hidden_variant_size').val()) {
              let sizeObj = JSON.parse($('#hidden_variant_size').val());
              if ('single' in sizeObj) {
                  $('#hidden_property_standardized_width').val(sizeObj.single.width);
                  $('#hidden_property_standardized_height').val(sizeObj.single.height);
              }
          }
      }
  });
  
  // Prevent external changes to the hidden property
  setInterval(() => {
      if (isLocked && $('#hidden_property_standardized_sided').val() !== "Double") {
          // console.log('Re-enforcing value to Double');
          $('#hidden_property_standardized_sided').val("Double").trigger('change');
      }
  }, 200);
  
 
 
 
  

  $("#modal-addtocart").on('click', function(){
      $(this).prop('disabled',true);
        window.localStorage.setItem('pprint-sp', JSON.stringify([]));
      window.localStorage.setItem('pprint-projects', JSON.stringify({}));
      $(".modal_loading").removeClass('hide');
      $(this).find('svg').attr('class','loading-svg');
      return add_to_cart();
  })
  $('#gobackto-editor').on('click',function(){
      $('#pp-design-preview-modal').attr('goback','true');
      $('#pp-design-preview-modal').modal('hide');
      $("#pp-designs-section").removeClass('hide');
      window.ppclient.showApp();
  })
  
  function updateProductMiniDetail(){
     let product_title = $(".product__title h1").html();
    let option_selected_text =  $(".option.clicked").find("b").text();
      $('#product-mini-detail .config-list').html("");
      $("#product-mini-detail .config-list").append('<div class="item title__config"><strong>Product</strong> <span>' + product_title +'</span></div>');
      $("#product-mini-detail .config-list").append('<div class="item quantity__config"><strong>Quantity</strong> <span>' + $(".quantity__input").val() +'</span></div>');
    $('.selector-wrapper').each(function(){
      
        let fieldLabel = $(this).find('.optionlabel').html();
          
        //console.log(fieldLabel);
        if(fieldLabel == undefined){
          fieldLabel = '';
        
        }
        
        let fieldValue = $(this).find('select option:selected').html();
       

        if ((fieldValue || '').trim() !== 'Default Title') {
        // Add a space before (mm) only if it's directly attached to the text (no space)
        let formattedLabel = fieldLabel.replace(/([^\s])(\(mm\))/i, '$1 $2');

        let optionHTML = '<div class="item"><strong>' + formattedLabel + '</strong> <span>' + fieldValue + '</span></div>';
        $('#product-mini-detail .config-list').append(optionHTML);
        }


    });

// Fix the spacing issue if needed
option_selected_text = option_selected_text.replace("Print-ReadyDesign", "Print-Ready Design");

$("#product-mini-detail-2 .config_list #artwork_needed").html(option_selected_text);

    //$("#product-mini-detail .config-list").append('<div class="item"><strong>How can we get your order to you?</strong> <span>' + $("#shipping_value").val() +'</span></div>');
    const shipping_val = $("#shipping_value").val();
let shipping_text = shipping_val;

// If it's delivery, add hyperlink
if (shipping_val.toLowerCase() === 'delivery') {
    shipping_text = '<a href="/pages/shipping-information" javascript:void(0) style="color: #000000;" target="_blank">Delivery</a>';
}

$("#product-mini-detail .config-list").append(
    '<div class="item"><strong>How can we get your order to you?</strong> <span>' + shipping_text + '</span></div>'
);

    let dpoValues = (typeof dpoOptions !== 'undefined') ? dpoOptions.getAllOptionValues() : [];
    dpoValues.forEach(function(value){
      if (value.title.indexOf('_Top') !== -1 && 
      value.title.indexOf('_Left') !== -1 && 
      value.title.indexOf('_Right') !== -1 && 
      value.title.indexOf('_Bottom') !== -1) {
      }      
      
        if(value.title){
          // console.log(value.title);
              if(!value.title.includes("Calendly event")&& !value.title.includes("Price per design") 
              && !value.title.includes("_TopBleed") 
              && !value.title.includes("_BottomBleed") 
              && !value.title.includes("_RightBleed") 
              && !value.title.includes("_LeftBleed")
              && !value.title.includes("_TopDeadArea")
              && !value.title.includes("_BottomDeadArea")
              && !value.title.includes("_RightDeadArea")
              && !value.title.includes("_LeftDeadArea"))
              {
                  let optionHTML="";
                  if(Array.isArray(value.value)){
                  let valString = value.value.map(function(d){return d.title}).join(",");
                //  optionHTML = '<div class="selected-option"><span class="selected-option-label">'+value.title+'</span><span class="selected-option-value">'+valString+'</span></div>';
                optionHTML = '<div class="item"><strong>'+value.title+'</strong>  <span>'+valString+'</span></div>';
                  }else{
                //  optionHTML = '<div class="selected-option"><span class="selected-option-label">'+value.title+'</span><span class="selected-option-value">'+value.value+'</span></div>';
                optionHTML = '<div class="item"><strong>'+value.title+'</strong>  <span>'+value.value+'</span></div>';
                  }    
                  //$('.selected-options-list').append(optionHTML);
                  $('#product-mini-detail .config-list').append(optionHTML);
        
  }
  
}   
  })
    let totalPrice = $("#totalPrice").html();
    $("#product-mini-detail .total--price").html(totalPrice);



    // Render Total to Next Border

                 // Retrieve the total price from the HTML
                 let total_Price = $("#totalPrice").html();
                 //console.log("Original Total Price: ", total_Price);
               
                 // Remove non-numeric characters (except for the decimal point) and convert the total price to a number
                 let totalPriceNumber = parseFloat(total_Price.replace(/[^0-9.]/g, ''));
                 //console.log("Parsed Total Price Number: ", totalPriceNumber);
                 let quantity__input = $(".quantity__input").val();
                
             
                 // Check if quantity__input is valid and convert it to a number
              
             
            
                 // Ensure totalPrice is a valid number before performing the calculation
                 if (!isNaN(totalPriceNumber)) {
                   // Calculate the GST (10% of the total price)
                   let gstAmount = totalPriceNumber * 0.09090909;
                  // console.log("GST Amount: ", gstAmount);
               
                  if (!isNaN(quantity__input) && quantity__input > 0) {
                    let quantity = parseFloat(quantity__input);
                    let pricePerUnit = totalPriceNumber / quantity;
            
                    // Update the HTML with the price per unit
                    //$("#product-mini-detail-2 .config_list #fprice").html(`$${pricePerUnit.toFixed(2)}`);
                    $("#product-mini-detail-2 .config_list #fprice2").html(`$${pricePerUnit.toFixed(2)}`); 
                } else {
                 $("#product-mini-detail-2 .config_list #fprice2").html(`$${pricePerUnit.toFixed(2)}`); 
                }
               
                   let increasedPrice = totalPriceNumber * 2.10; 
               
                   let gstAmount2 = increasedPrice * 0.10;
                  // console.log("GST Amount2: ", gstAmount2);
                  // console.log("Increased Price: ", increasedPrice);
                   let total_Price = increasedPrice +  gstAmount2;
                  // console.log("Total Price: ", total_Price);
                   let final_total = totalPriceNumber -  gstAmount;
                  // console.log("Final Total Price: ", final_total);
                  
               
                   $("#strike-through").html(`$${increasedPrice.toFixed(2)}`); // Show original price
                 $("#product-mini-detail-2 .config_list #gstAmount").html(`$${gstAmount.toFixed(2)}`);
                 $("#product-mini-detail-2 .config_list #fprice").html(`$${final_total.toFixed(2)}`); // Show increased price
                 //$("#product-mini-detail-2 .config_list #tprice").html(`$${final_total.toFixed(2)}`); // Show Final price
               
                 $("#product-mini-detail-3 .config_list #fprice").html(`$${totalPriceNumber.toFixed(2)}`); // Show increased price
                 $("#product-mini-detail-3 .config_list #tprice").html(`$${totalPriceNumber.toFixed(2)}`); // Show Final price
                 $("#strike-through2").html(`$${total_Price.toFixed(2)}`); // Show original price
                 $("#quote_total").html(`$${final_total.toFixed(2)}`); // Show original price
                 } else {
                   console.error("Total price is not a valid number.");
                 }


  }

// Date and Time

function formatDate(date) {
  const options = { year: 'numeric', month: 'long', day: '2-digit' };
  return date.toLocaleDateString('en-US', options);
}

const today = new Date();
const futureDate = new Date();
futureDate.setDate(today.getDate() + 7);

//$('#today-date').text(formatDate(today));
$('#till-date').text(formatDate(futureDate));
function resetDesignButton(){
  $('#resetDesignButton').on('click', function() {
    if (typeof pitchprint !== 'undefined' && pitchprint.api && pitchprint.api.resetDesign) {
        pitchprint.api.resetDesign();
    } else {
        console.error("PitchPrint API is not loaded or the resetDesign method is unavailable.");
    }
});
}
function RedirectBack(){
  $("#confirm_order").css("display","none").addClass("hidden");
  $('.cart-price-wrapper').addClass("hidden");
  $("#total_loader").css("display","block").removeClass("hidden");
  $(".wraper-form").addClass("hidden");
  setTimeout(function(){
    $("#total_loader").css("display","none").addClass("hidden");
    $("#quote-tab").removeClass("hide");  
    $(".wraper-form").removeClass("hidden");
     $(".design__block__form").show();
     $("variant-selects").show();
     resetDesignButton();
  }, 5000);
  
}
    
    function projectSaved(_val){    
      RedirectBack();
      $("#skip_upload").trigger("click");
      
    //  $("#pp-designs-section").css("display","block");
      let _data = _val.data,_previewDiv = document.getElementById('pp_preview_div');
      $("#pp_preview_div").html("");
      let pId = _data.projectId;
      $("#hidden_property_saved_project_id").val(pId);
      $('#pitchprint_preview_pdf').val("https://pdf.pitchprint.io?id="+pId);
      if (_data && _data.previews && _data.previews.length) {
          let cuTime = new Date().getTime();
          _previewDiv.innerHTML = _data.previews.reduce((_str, _prev) => `${_str}<img src="${_prev}?${cuTime}">`, '');		//Show the preview images
      }    
      $("#pitchprint_preview_hidden").val($("#pp_preview_div img").attr('src')); 
    
    $('.selected-options-list').html("");
    $('.selector-wrapper.swhidden').each(function(){
        let fieldLabel = $(this).find('label').html();
        if(fieldLabel == undefined){
          fieldLabel = '';
        }
        let fieldValue = $(this).find('select option:selected').html();
        let optionHTML = '<div class="selected-option"><span class="selected-option-label">'+fieldLabel+'</span><span class="selected-option-value">'+fieldValue+'</span></div>';
        $('.selected-options-list').append(optionHTML);
    })
    let dpoValues = (typeof dpoOptions !== 'undefined') ? dpoOptions.getAllOptionValues() : [];
    dpoValues.forEach(function(value){
        if(value.title){
              if(!value.title.includes("Calendly event")&& !value.title.includes("Price per design")){
                  let optionHTML="";
                  if(Array.isArray(value.value)){
                  let valString = value.value.map(function(d){return d.title}).join(",");
                  optionHTML = '<div class="selected-option"><span class="selected-option-label">'+value.title+'</span><span class="selected-option-value">'+valString+'</span></div>';
                  }else{
                  optionHTML = '<div class="selected-option"><span class="selected-option-label">'+value.title+'</span><span class="selected-option-value">'+value.value+'</span></div>';
                  }    
                  $('.selected-options-list').append(optionHTML);
              }            
        }    
    })
    $("#selected-qty-option .selected-option-value").html($(".quantity__input").val());
    let totalPrice = $("#totalPrice").html();
    $('.selected-options-list').append('<div class="selected-option"><span class="selected-option-label">Total</span><span class="selected-option-value">'+totalPrice+'</span></div>');
    window.dpoOptions.updatePrice();
    $('.approveDesignProof__download').attr('href','https://pdf.pitchprint.io?id='+pId);
    $("#pp-design-preview-modal").attr('goback','false');
    $("#pp-design-preview-modal").modal('hide');
    $("#pp-designs-section").addClass('hide');
  };
  window.ppDesignerInitialized = function(_class) {  
    ppclient.on('project-saved', projectSaved);
    ppclient.on('editor-shown', function(){
      $("#pp-design-editor iframe:first-child").css('max-height',$(window).height());
      $("#pp-design-editor iframe:first-child").css('height',$(window).height());
      
      let sizeOptionText = $('.popular select option:selected').html();       
      if(sizeOptionText!=undefined){
          if(sizeOptionText.includes('Custom')){                 
              let productWidth = parseInt($('.custom-box.width input').val());
              let productHeight = parseInt($('.custom-box.height input').val());
              // console.log('size-custom-here',productWidth,productHeight);
              window.ppclient.fire('resize-page', { width: productWidth, height: productHeight}); 
          }
      }
    });
    ppclient.on('before-show', function(){
      $('.design-editor-loading').addClass('hide');
      $('.design-editor-loading').parent().addClass('hide');
        let sizeOptionText = $('.popular select option:selected').html();       
      if(sizeOptionText!=undefined){
          if(sizeOptionText.includes('Custom')){                 
              let productWidth = parseInt($('.custom-box.width input').val());
              let productHeight = parseInt($('.custom-box.height input').val());
              // console.log('size-custom-here',productWidth,productHeight);
              window.ppclient.fire('resize-page', { width: productWidth, height: productHeight}); 
          }
      }
    });
    ppclient.on('design-loaded', function(){
        let sizeOptionText = $('.popular select option:selected').html();       
      if(sizeOptionText!=undefined){
          if(sizeOptionText.includes('Custom')){     
              let productWidth = parseInt($('.custom-box.width input').val());
              let productHeight = parseInt($('.custom-box.height input').val());
              window.ppclient.fire('resize-page', { width: productWidth, height: productHeight}); 
          }
      }
    });
  }
  $("#getQuoteWithDesignForm").on("hidden.bs.modal", function (e) {
      $('#pp-design-preview-modal').attr('goback','true');    
      $("#pp-designs-section").removeClass('hide');
      window.ppclient.showApp();
  });
  $("#pp-design-preview-modal").on("hidden.bs.modal", function (e) {
      if($("#pp-design-preview-modal").attr("goback")!="true"){
          // window.localStorage.setItem('pprint-sp', JSON.stringify([]));
          // window.localStorage.setItem('pprint-projects', JSON.stringify({}));
          // location.reload();
          $('#pp-design-preview-modal').attr('goback','true');    
          $("#pp-designs-section").removeClass('hide');
          window.ppclient.showApp();
      }        
  });
  
  $("#scroll-up-buy-more").on('click', function(e){    
    e.preventDefault(true);    
    var y = $('#itier_prices').scrollTop(); // current page position
    $('#itier_prices').scrollTop(y - 25); // scroll up 150px
  });

  $("#scroll-down-buy-more").on('click', function(e){
    e.preventDefault(true);
    var y = $('#itier_prices').scrollTop(); // current page position
    $('#itier_prices').scrollTop(y + 25); 
  });

$('.itier_price.selectable').on('click', function(e){
  /* 2026-08-19: removed the mobile animate-to-thumbnail-slider that fired here.
     Picking a quantity tier scrolled the customer AWAY from the tier grid back up
     to the image gallery (1s animation) — the main "page keeps jumping when I
     choose options" complaint. Selection state is all this handler needs to do. */
  $('.itier_price.selectable').removeClass('selected');
  $(this).addClass('selected');
});



/*
  window.tpAfterLoad = function(){    
    // console.log('tpAfterLoad');
    jQuery('#buy-more-section').after(jQuery('.tp-container'));
    jQuery('.itier_price.selectable span').each(function(){
      var html = $(this).html();
      html = html.replace("-ospan-",'<span class="save-percent">');
      html = html.replace("-cspan-",'</span>');      
      $(this).html(html);
  	})
  }
*/
  let galleryWrapperWidth = $("#product-gallery-wrapper").width();
  // $(window).scroll(function() {
  //     let headerHeight = 80;
  //     if($(window).width()>768){      
  //     var tP = $('#product-descriptions-wrapper').offset().top;
  //     if ($(this).scrollTop() > tP) {
  //       $("#product-image-wrapper").addClass('sticky');
  //         $("#product-image-wrapper").css('width',galleryWrapperWidth+'px');
  //       var maxLimit = $("#product-description-container").offset().top + $("#product-description-container").height() - $("#product-image-wrapper").height();
  //       if ($(this).scrollTop() > maxLimit) {
  //         $("#product-image-wrapper").css('top', maxLimit - $(this).scrollTop() + 'px');
  //       } else {
  //         $("#product-image-wrapper").css('top', '0px');
  //       }
  //     } else {
  //       $("#product-image-wrapper").removeClass('sticky');
  //     }
  //     }
  // });
 
function printSides() {
  // Current product ID (Shopify)
  let productId = $('input[name="product-id"], input[name="id"]').first().val();
  // Combine selected text from Printed Sides or Printed Graphic
  let printedSides = $('select[name="options[Printed Sides]"] option:selected, select[name="options[Printed Graphic]"] option:selected').text();
  
  // Selected Graphic text
  let graphicOption = $('select[name="options[Graphic]"] option:selected').text();
  
  // Combine both
  let combinedOptions = printedSides + ', ' + graphicOption;
  
  // Match Single/Double Sided (with or without hyphen)
  let regex = /Single[-\s]?Sided|Double[-\s]?Sided/gi;
  
  // Extract matching text
  let extractedOptions = combinedOptions.match(regex);
  
  // Join matches
  let print_sides = extractedOptions ? extractedOptions.join(', ') : '';
  // 🔥 PRODUCT-SPECIFIC OVERRIDE
  if (productId == '7403662508101') {
    print_sides = 'Single Sided';
  }
  // Update hidden input
  $("#hidden_printing_sided").val(print_sides.trim());
  
  // console.log('Updated hidden field:', print_sides);
}

// Run once on page load
$(document).ready(function() {
  printSides();

  // Run again when dropdowns change
  $(document).on('change', 'select[name="options[Printed Sides]"], select[name="options[Graphic]"], select[name="options[Printed Graphic]"]', function() {
    printSides();
  });
});

$(document).on('change', 'options[Size]', function(e){
    let text_includes = $(".single-option-selector option:selected").text();
    //console.log(text_includes);
});

    $(document).on('change','.single-option-selector, .select, .select2-hidden-accessible, .admin__control-select', function(e){
       
        setTimeout(function(){
      $(".initialized span").text("Calculate Price");
    }, 1000);
    //  console.log('selector onchange', $(this).closest('.selector-wrapper').children("label").html());
     // console.log('selector onchange', $(this).parent().find('.optionlabel').html());
// Custom Design 

   /*var text_includes =  $(".single-option-selector option:selected").text().includes('Custom Printed ( Any Design )');
    if(!text_includes){
      jQuery(".requiredesignstep, .view_pp_templates").addClass("hide");
      jQuery(".add-cart-wrapper .add_to_cartbtn").removeClass("hide");
      
      jQuery("#getQuote").css({"margin-top":"10px", "float":"left"});
      }else{
  jQuery(".requiredesignstep, .view_pp_templates").removeClass("hide").removeAttr("style");
      jQuery(".add-cart-wrapper .add_to_cartbtn").addClass("hide");
      //jQuery("#getQuote").css('margin-top', '0px');
    }

*/

// console.log(    $("#productSelect").trigger('change'));
         
     $("#productSelect").trigger('change');
    // $("#productSelect").val();
      // Fill Standardized Data Manually
      setTimeout(function(){
        let attachmentSelector = "#advance_attachment_"+$('#productSelect').val();
        let fileVal = $(attachmentSelector).val();            
        if(fileVal!=undefined){
            $("#file_attachment").val(fileVal);
        }
          let widthSelector = "#standardized_width_"+$('#productSelect').val();
          let widthVal = $(widthSelector).val();            
          if(widthVal!=undefined){
              $("#hidden_property_standardized_width").val(widthVal);
          }
          let widthSelector2 = "#standardized_width_external_"+$('#productSelect').val();
          let widthVal2 = $(widthSelector2).val();   
          if(widthVal2!=undefined){
              $("#hidden_property_standardized_width_external").val(widthVal2);
          }
          let heightSelector = "#standardized_height_"+$('#productSelect').val();
          let heightVal = $(heightSelector).val();            
          if(heightVal!=undefined){
              $("#hidden_property_standardized_height").val(heightVal);
          }
          
          let sidedSelector = "#standardized_sided_"+$('#productSelect').val();
          let sidedVal = $(sidedSelector).val();            
          if(sidedVal!=undefined){
              $("#hidden_property_standardized_sided").val(sidedVal);
          }else{
              $("#hidden_property_standardized_sided").val("Single");
          }
          
          let materialSelector = "#standardized_material_"+$('#productSelect').val();
          let materialVal = $(materialSelector).val();            
          if(materialVal!=undefined){
              $("#hidden_property_standardized_material").val(materialVal);
          }
  
          let rollSizeSelector = "#standardized_roll_size_"+$('#productSelect').val();
          let rollSizeVal = $(rollSizeSelector).val();            
          if(rollSizeVal!=undefined){
              $("#hidden_property_standardized_roll_size").val(rollSizeVal);
          }

          let TemplateSelector = "#template_name_"+$('#productSelect').val();
          let TemplateName = $(TemplateSelector).val();            
          if(TemplateName!=undefined){
              $("#hidden_template_name").val(TemplateName);
          }

          let ProductMaterialSelector = "#sides_print_material_"+$('#productSelect').val();
          let ProductVariantMaterialSelector = $(ProductMaterialSelector).val();            
          if(ProductVariantMaterialSelector!=undefined){
              $("#variant_product_material").val(ProductVariantMaterialSelector);
          }
      let TemplateUrlSelector = "#template_link_"+$('#productSelect').val();
          let TemplateFileUrl = $(TemplateUrlSelector).val();            
          if(TemplateFileUrl!=undefined){
              $("#hidden_template_file_link").val(TemplateFileUrl);
          }
  let PrintingSelector = "#backside_printing_"+$('#productSelect').val();
          let BackSidePrint = $(PrintingSelector).val();            
          if(BackSidePrint!=undefined){
              $("#hidden_backside_printing").val(BackSidePrint);
          }
 let PrintingPageSelector = "#printing_pages_"+$('#productSelect').val();
          let PrintPages = $(PrintingPageSelector).val();            
          if(PrintPages!=undefined){
              $("#hidden_printing_pages").val(PrintPages);
          }
  
        if($("#hidden_json_standardized_data").val()!=undefined){
            let standardized_data = JSON.parse($("#hidden_json_standardized_data").val());
            if(typeof standardized_data[$('#productSelect').val()] != 'undefined'){
                let currentVariant = standardized_data[$('#productSelect').val()];
                $("#hidden_property_standardized_sided").val(currentVariant['sided']);
                $("#hidden_property_standardized_width").val(currentVariant['width']);
                $("#hidden_property_standardized_height").val(currentVariant['height']);
            }
        }        
        if(e.originalEvent !==undefined){            
        let ppcatSelector = "#ppcatid-"+$('#productSelect').val();
        let pitchprint_catid = $(ppcatSelector).val();            
        if(pitchprint_catid!=undefined){
          if(pitchprint_catid.includes('pp-cat-')){
            pitchprint_catid = pitchprint_catid.substr(7);
            // console.log(pitchprint_catid);
          }
          $("#pp_design_cat_hidden_id").val(pitchprint_catid);    
          getPPDesignPreviewImages();
        }   
      }  
      }, 100);
    });
  
       $("#design-idea-textarea").on('keydown', function(){
       
          if($(this).val()!=""){              
              $("#continue_cart").removeClass("hide");
          }
      })
      $(document).on('change keyup', "textarea.uploadkit-textarea", function(){
            var invalidChars = /[^0-9]/gi
          if(invalidChars.test($(this).val())) {
              $(this).val("");
          }else{
              let sum = 0 ;
  
              $('textarea.uploadkit-textarea').each(function(){
                  if(!isNaN(parseInt($(this).val()))){
                      sum += parseInt($(this).val());
                  }                
              })
              if(!isNaN(parseInt($(".quantity__input").val()))){
                    if(sum > $(".quantity__input").val()){
                    if(!$('.uploadkit-thumbnails .err-msg').length){
                        $('.uploadkit-thumbnails').append('<p class="err-msg">Total number of designs ordered = '+$(".quantity__input").val()+'</p>');
                        setTimeout(function(){$('.uploadkit-thumbnails p.err-msg').remove();},5000);
                    }                
                    $(this).val("");
                }        
          }else{
            if(sum > 1){
                    if(!$('.uploadkit-thumbnails .err-msg').length){
                        $('.uploadkit-thumbnails').append('<p class="err-msg">Total number of designs ordered = 1</p>');
                        setTimeout(function(){$('.uploadkit-thumbnails p.err-msg').remove();},5000);
                    }                
                    $(this).val("");
                } 
          }
          }
      })
  
      $("input[type='radio'][name='schedule_meeting']").on('change', function(){
          if($(this).val()=="yes"){
              // console.log('yes');
              $(".dpo_meeting_option .choice input").prop('checked',false);
              $(".dpo_meeting_option .choice.yes input").prop('checked', true);
              window.dpoOptions.updatePrice();
              if($("#hidden_meeting_scheduled").val()!='scheduled'){
                  $('.calendly-badge-content').trigger('click');
              }            
          }else{
              // console.log('no');            
              $(".dpo_meeting_option .choice input").prop('checked',false);
              $(".dpo_meeting_option .choice.no input").prop('checked', true);
              window.dpoOptions.updatePrice();
          }
      })
      function isCalendlyEvent(e) {
          return e.data.event && e.data.event.indexOf('calendly') === 0;
      };
      
      window.addEventListener(
          'message',
          function(e) {
              if (isCalendlyEvent(e)) {
                  if(e.data.event=='calendly.event_scheduled'){
                        $("#hidden_property_confirmed_meeting").val("Meeting Confirmed");
                      $("#schedule_meeting + strong").html("let's schedule time to review online (Appointment Confirmed Details Emailed)");
                      $(".calendly-popup-close").trigger('click');
                      $("#hidden_meeting_scheduled").val('scheduled');
                  }
              }
          }
      );
    
      $('#get_quote_with_design_btn').on('click',function(){
       
      if($("#get_quote_design_customer_email").val()!=""){                
          let priceArray = window.dpoOptions.updatePrice();        
          var data = {
          "email":$("#get_quote_design_customer_email").val(),
          "variant_id":$("#productSelect option:selected").val(),
          "title":$("#hidden_product_title").val(),
          "qty":$(".quantity__input").val(),    
          "price":priceArray['current_prices']['price'],
          "variant_title": $("#productSelect option:selected").html(),
          "require_design":$("#require_design_services_hidden").val(),
          "delivery_option":$("#delivery_options_hidden").val(),
          "product_image":$("#hidden_product_img").val(),
          "custom_product":custom_size_box,
          "project_id":$("#hidden_property_saved_project_id").val(),
          "options":window.dpoOptions.getAllOptionValues(),
          "standardized_width":$("#hidden_property_standardized_width").val(),
          "standardized_height":$("#hidden_property_standardized_height").val(),
          "variantOptions":product.options,
          "product_url" :window.location.href,
            "product_id":product.id
          };  
          $.ajax({
              method: "POST",  
              url: "https://phpstack-321644-985620.cloudwaysapps.com/Email-Design.php", 
              data: data,
              success: function(result){        
                  $('#getQuoteWithDesignForm').modal('hide');
              }
          });  
        }      
  });
      

 

  $('.support-types .option').on('click', function(e) {
    
    // Get the selected value
    let selected_val = $(this).find('span').text();
    $("#require_support_hidden").val(selected_val);
  
    // Find the container
    let container = $(this).closest('.support-types');
    let container_radio = $(this).parent().find('input');
    let radio_id = $(this).attr('id');
    $(container_radio).each(function(){
      let radioId = $(this).attr('id');
      // console.log($(radioId));
      if(radioId === radio_id){
        $(this).attr('checked', 'checked');
      } else {
        $(this).removeAttr('checked', 'checked');
     }
    })
    // $(container_radio).each(function() {
    //   console.log($(this).val());
    // });
    // Check or uncheck the radio buttons
    // container.find('input[type="radio"]').prop('checked', false);
    
    // if (selected_val) {
    //   $(this).siblings('input[type="radio"]').prop('checked', true);

    // }
    // Apply condition based on the value
    if (selected_val === 'Zoom Meeting') {
      $(".meeting-wrapper").removeClass("hidden");
    } else {
      $(".meeting-wrapper").addClass("hidden");
    }
    if(e.originalEvent !==undefined){            
      createDraftOrder();   
  }
  });
  

  
  
  
  
    function approveDesign(){
        $("#modal-addtocart").show();
        $("#approve-design,#gobackto-editor").hide();
        $("#email-design,#customer-email").hide();
    }
  
      $("#email-design").on('click',function(){
          $("#pp-design-preview-modal").modal('hide');
          $('#pp-design-preview-modal').attr('goback','true');
          $("#getQuoteWithDesignForm").modal('show');
      })
   
  function createDraftOrder(){
    let product = $("#product_json").val();
      if(window.dpoOptions){
          let autoQuoteEmail = "";
  
          let priceArray = window.dpoOptions.updatePrice();
                  
          
          autoQuoteEmail = 'noemail';
           
          autoQuoteEmail = autoQuoteEmail.replace(/\s/g, '');
            var data = {
              "email":autoQuoteEmail,
              "variant_id":$("#productSelect option:selected").val(),
              // "title":product.title,
             // "title":$("#hidden_product_title").val(),
             "title":$("#hidden_product_title").val(),
              "qty":$(".quantity__input").val(),    
              "price":priceArray['current_prices']['price'],
              "variant_title": $("#productSelect option:selected").html(),
              "require_design":$("#require_design_services_hidden").val(),
              "delivery_option":$("#delivery_options_hidden").val(),
              // "product_image":product.featured_image,
              "product_image":$("#hidden_product_img").val(),
              //"product_image":$("#hidden_product_img").val(),
              "custom_product":custom_size_box,
              "options":window.dpoOptions.getAllOptionValues(),
              "variantOptions":product.options,
        "standardized_width":$("#hidden_property_standardized_width").val(),
        "standardized_height":$("#hidden_property_standardized_height").val(),
        "standardized_sided":$("#hidden_property_standardized_sided").val(),
        "_TopBleed":$("#TopBleed").val(),
        "_BottomBleed":$("#BottomBleed").val(),
        "_RightBleed":$("#RightBleed").val(),
        "_LeftBleed":$("#LeftBleed").val(),
        "_ProductGroup":$("#ProductGroup").val(),
        "_Box_Required":$("#box_required").val(),
        "_TopDeadArea":$("#TopDeadArea").val(),
        "_BottomDeadArea":$("#BottomDeadArea").val(),
        "_RightDeadArea":$("#RightDeadArea").val(),
        "_LeftDeadArea":$("#LeftDeadArea").val(),
        "_Material":$("#hidden_property_standardized_material").val(),
        "_Shape":$("#product_shape").val(),
        "_Standardized_Weight":$("#product_weight").val(),
        "_Standardized_Thickness":$("#hidden_property_standardized_thickness").val(),
        "_Bleed_Sides":$("#bleed_sides").val(),
        "_Bleed":$("#bleed_thickness").val(),
        "_Pages":$("#printing_pages").val(),
        "_TOTAL_SQM":$("#hidden_property_standardized_sqm").val(),
        "_Backside Blank":$("#hidden_backside_printing").val(),
        "_PRODUCT_TITLE":$("#hidden_property_product_title").val(),
        "_Bubble_Product_Type":$("#bubble_product_type").val(),
        "_Bubble_Flow_Type":$("#bubble_flow_type").val(),
        "_Bubble_Printer_Name":$("#bubble_printer_name").val(),
        "product_url" :window.location.href,
        "product_id":product.id
          };
    
          
          $.ajax({
              method: "POST",  
              url: "https://phpstack-321644-985620.cloudwaysapps.com/Quote-form.php", 
              data: data,
              success: function(result){           
              if(result == "Email has sent successfully."){
                  // console.log('draft order has been created');      
              }else{
                  // console.log('something went wrong');
              }
              }
  
          });
      }    
     
  }
  
    
        // trigger after DPO price update
  jQuery(window).on('dpoPriceUpdate', function(e, o){   
      let coriflute_id = $("#coriflute_id").val();
    // console.log('dpoPriceUpdate');

      if(coriflute_id == 1312616939589){
      jQuery("#totalPrice").html(dpoOptions.formatPrice(o.current_prices.price * $(".quantity__input").val()));
      jQuery('#hidden_unit_price').val(o.current_prices.price);
    
    }
    else{
      let quantity = parseInt($(".quantity__input").val()) || 1;
  
  // Get the base unit price from tier pricing
  let tierUnitPrice = 0;
  let matchedTier = false;
  
  // Find the matching tier price
  $('.itier_price').each(function() {
    let tierQty = parseInt($(this).attr('qty'));
    let tierPrice = parseFloat($(this).attr('price'));
    
    if (quantity >= tierQty) {
      tierUnitPrice = tierPrice;
      matchedTier = true;
    }
  });
  
  // If no tier matched, use the first/default tier
  if (!matchedTier && $('.itier_price').length > 0) {
    tierUnitPrice = parseFloat($('.itier_price').first().attr('price')) || 0;
  }
  
  // Calculate DPO options price (one-time fees)
  let dpoOptionsPrice = 0;
  
  // Get all selected DPO options and their prices
  $('select.product-custom-option option:selected').each(function() {
    let optionPrice = parseFloat($(this).attr('price')) || 0;
    dpoOptionsPrice += optionPrice;
  });
  
  $('input.product-custom-option:checked').each(function() {
    let optionPrice = parseFloat($(this).attr('price')) || 0;
    dpoOptionsPrice += optionPrice;
  });
  
  // Calculate total: (tier unit price × quantity) + DPO options (one-time)
  let totalPrice = (tierUnitPrice * quantity) + dpoOptionsPrice;
  
  jQuery("#totalPrice").html(dpoOptions.formatPrice(totalPrice));
  jQuery('#hidden_unit_price').val(tierUnitPrice);
    }
      if($(".quantity__input").val()>1){
        let is_modal_show = localStorage.getItem('alreadyShow');
        if(is_modal_show != 'alredy shown'){
       $("#multiple-designs").show();
       $("#multiple-designs").insertBefore(".design__block__form");
       localStorage.setItem('alreadyShow','alredy shown');
        }
        else{
            // console.log(is_modal_show);
        }
    } 

    $('.itier_price.selectable').each(function(){
        if($(".quantity__input").val() == $(this).attr('qty')){
          $('.itier_price.selectable').removeClass('selected');
          $(this).addClass('selected');          
          var y = $(this).position().top;
          $('#itier_prices').scrollTop(y); // scroll up 150px
        }
    })    


  });
    /* send request to custom php app for draft order */
    $("#get_quote_form_btn").click(function(){
      var product = $("#product_json").val();
      var $qbtn = $(this); $qbtn.prop("disabled", true).text("Sending..."); setTimeout(function(){ $qbtn.prop("disabled", false).text("Email me a quote"); }, 8000);
      // console.log(JSON.stringify(product));
      let priceArray = window.dpoOptions.updatePrice();    
      
         var data = {
        "email":$("#get_quote_customer_email").val(),
        "variant_id":$("#productSelect option:selected").val(),
        // "title":product.title,
        "title":$("#hidden_product_title").val(),
        "qty":$(".quantity__input").val(),    
        "price":priceArray['current_prices']['price'],
        "variant_title": $("#productSelect option:selected").html(),
        "require_design":$("#require_design_services_hidden").val(),
        "delivery_option":$("#delivery_options_hidden").val(),
        //"product_image":product.featured_image,
        "product_image":$("#hidden_product_img").val(),
        "custom_product":custom_size_box,
        "options":window.dpoOptions.getAllOptionValues(),
        "standardized_width":$("#hidden_property_standardized_width").val(),
        "standardized_height":$("#hidden_property_standardized_height").val(),
        "standardized_sided":$("#hidden_property_standardized_sided").val(),
        "_ProductGroup":$("#ProductGroup").val(),
        "_Box_Required":$("#box_required").val(),
        "_TopBleed":$("#TopBleed").val(),
        "_BottomBleed":$("#BottomBleed").val(),
        "_RightBleed":$("#RightBleed").val(),
        "_LeftBleed":$("#LeftBleed").val(),
        "_TopDeadArea":$("#TopDeadArea").val(),
        "_BottomDeadArea":$("#BottomDeadArea").val(),
        "_RightDeadArea":$("#RightDeadArea").val(),
        "_LeftDeadArea":$("#LeftDeadArea").val(),
        "_Material":$("#hidden_property_standardized_material").val(),
        "_Shape":$("#product_shape").val(),
        "_Standardized_Weight":$("#product_weight").val(),
        "_Standardized_Thickness":$("#hidden_property_standardized_thickness").val(),
        "_Bleed_Sides":$("#bleed_sides").val(),
        "_Bleed":$("#bleed_thickness").val(),
        "_Pages":$("#printing_pages").val(),
        "_TOTAL_SQM":$("#hidden_property_standardized_sqm").val(),
        "_Backside Blank":$("#hidden_backside_printing").val(),
        "_PRODUCT_TITLE":$("#hidden_property_product_title").val(),
         "_Bubble_Product_Type":$("#bubble_product_type").val(),
         "_Bubble_Flow_Type":$("#bubble_flow_type").val(),
         "_Bubble_Printer_Name":$("#bubble_printer_name").val(),
        "product_url" :window.location.href,
        "product_id":product.id
      }; 
      $.ajax({
        method: "POST",  
        url: "https://phpstack-321644-985620.cloudwaysapps.com/Quote-form.php", 
        data: data,
  
        success: function(result){           
          if(result == "Email has sent successfully."){
            $('.thankyou-message').removeClass('hide');
            $("#getQuoteForm .modal-header h3").html("Thank you!");
            $(".form-first").addClass('hide');        
          }else{
            $(".form-first").addClass('hide');
            $('.error-message').removeClass('hide');
          }
          $("#quote_close_btn").addClass('hide');
          $("#get_quote_form_btn").addClass('hide');
          $('#continue_shopping_btn').removeClass('hide');
          $('#quote_to_cart_btn').removeClass('hide');
        }
  
      });
     
    });
  
      $("#continue_to_design").on('click', function(){
          $("#numberofdesignsdropdown").val(1);
          $("#numberofdesignsdropdown").trigger('change');
          $('.hidden_no_design input').val(1);          
      })
  
      $("#not_use_editor").on('click', function(){
          $("#design_exist").trigger('click');          
      });
    /* email options  till qty */
    $("#get_options").click(function(){
      let product_title =  $("#hidden_product_title").val();
      let priceArray = window.dpoOptions.updatePrice();    
      var data = {
        "email":$("#quote_customer_email").val(),
        "variant_id":$("#productSelect option:selected").val(),
        "title":product_title+"-"+$("#productSelect option:selected").attr("data-sku"),
        "qty":$(".quantity__input").val(),    
        "price":priceArray['current_prices']['price'],
        "variant_title": $("#productSelect option:selected").html(),
        //"product_image":product.featured_image,
        "product_image":$("#hidden_product_img").val(),
        "custom_product":custom_size_box,
        "options":window.dpoOptions.getAllOptionValues(),
        "product_url" :window.location.href
      };  
      $.ajax({
        method: "POST",  
        url: "https://phpstack-321644-985620.cloudwaysapps.com/Quote-options.php", 
        data: data,
  
        success: function(result){           
          if(result == "Email has sent successfully."){
            $('.thankyou-message').removeClass('hide');
            $(".form-first").addClass('hide');        
          }else{
            $(".form-first").addClass('hide');
            $('.error-message').removeClass('hide');
          }
          $("#quote_close_btn").addClass('hide');
          $("#get_quote_form_btn").addClass('hide');
          $('#continue_shopping_btn').removeClass('hide');
          $('#quote_to_cart_btn').removeClass('hide');
        }
  
      });  
    });
  $(document).on('click','.customize_design', function(e){
   
         // e.preventDefault();    
     if($("#require_design_services_hidden").val()=="Design tool"){
            //if($("#require_design_services_hidden").val()=="Online design from templates"){
              $("#pp-design-editor").removeClass('hide');
              $('.design-editor-loading').removeClass('hide');
              let designId = $(this).closest('.pitchprint_design').attr('design-id');
              window.ppclient.closeApp();   
              window.ppclient = new PitchPrintClient({
                  apiKey: 'vividads-com-au.myshopify.com',		
                  designId: designId,	
                  custom: true
              });            
              window.ppclient.showApp();                       
              let varintId = $("#productSelect").val();
              let hiddenVariantSizeSelector="#variant_size_"+varintId;            
              if(custom_size_box==""){
                if($(hiddenVariantSizeSelector).val()!=undefined){
                    let productSize = $(hiddenVariantSizeSelector).val().split('x');
                    ppclient.fire('resize-page', { width: 120, height: 100 });
                }        
              }else{
                let sizeHtml = $('.popular select option:selected').html() || '';
                if(sizeHtml.includes('x')){
                    let productSize = sizeHtml.split('x');
                }else{
                    let productWidth = parseInt($('.custom-box.width input').val());
                    let productHeight = parseInt($('.custom-box.height input').val());
                    if(productWidth!=""&&productHeight!=""){
                        ppclient.fire('resize-page', { width: productWidth, height: productHeight });
                    }
                }
              }        
              updateProductMiniDetail();              
               
              if($("#pp-design-editor").height()>0){
                  $("html, body").animate({ scrollTop: $("#pp-design-editor").offset().top }, 1000);                
              }
          }else{
          //  $("html, body").animate({ scrollTop: $("#product-description-container").offset().top }, 1000);
          }  
                    
      })
    
  $(".quantity__input").on('keyup change',function(e){
    if($(this).val()==1){
            
      $("#multiple-designs").hide();
       }
        
    $('.itier_price.selectable').each(function(){
        if($(".quantity__input").val() == $(this).attr('qty')){
          $('.itier_price.selectable').removeClass('selected');
          $(this).addClass('selected');
          // $("#multiple-designs").hide();       
        }
    })    
     
      if(e.originalEvent!==undefined){
          createDraftOrder();
          if(typeof window.dpoOptions!="undefined"){
            window.dpoOptions.updatePrice();   
          }          
      }    
  })
  
      
      let pitchprint_catid = $("#hidden_meta_pitchprint_category_id").val();    
  //     $(".view_pp_templates:not(.clicked)").click(function(){

  //       $("html, body").animate({ scrollTop: $(".optional-workflow-section.activesection").offset().top }, 50);  
  // });
  $(document).on('click', '.view_pp_templates:not(.clicked)', function(e){
    setTimeout(function(){
    //$("html, body").animate({ scrollTop: $(".optional-workflow-section.activesection").offset().top }, 1000);  
    }, 2000);
});
 

//  Reset Quote and Confirm Button

$(document).on('click', '#own_template', function(e) {
  if(window.mobileCheck()){
    $("html, body").animate({ scrollTop: $(".thumbnail-slider").offset().top + 100}, 1000);      
   // $("html, body").animate({ scrollTop: $("#total-elementor").offset().top  }, 1000)
  }
  $("#total_loader").removeClass("hidden").css("display","block");
  $(this).find("span").text("Start Designing");
  $("#total-elementor").addClass("hidden").css("display","none");
  //$(".how-works").addClass("hidden");
  $("#confirm_order .cart-price-wrapper").addClass("hidden");
  $(".pp-design-btn").addClass("hidden");
  $("#skip_upload").addClass("hide");
  $('button[onclick*="dpoOptions"]').each(function() {
    this.style.setProperty('display', 'none', 'important');
  });

  setTimeout(function(){
   
    $(".pp-design-btn").removeClass("hidden");
    $("#total_loader").addClass("hidden").css("display", "none");
    $("#confirm_order").removeClass("hidden").css("display","block");
    //$(".how-works").removeClass("hidden").css({"display": "block"});
    $(".cart-price-wrapper").removeClass("hidden").css({"display": "block"});
    $(".price-details").removeClass("hidden");
    $(".own_template").addClass("hidden");
    $(".optional-workflow-wrapper").removeClass("hidden");
    $(".design__upload").parent().hide();
   // $("html, body").animate({ scrollTop: $("#pp-designs-section").offset().top }, 1000);  
   $("#pp-designs-section").css("display","block");
  
   //$(".design__upload").parent().addClass("hidden");
    }, 2000);
 
});

$(document).on('click', '.confirm_order:not(#own_template)', function(e) {
  if(window.mobileCheck()){
    $("html, body").animate({ scrollTop: $("#total-elementor").offset().top - 10 }, 1000);      
   // $("html, body").animate({ scrollTop: $("#total-elementor").offset().top  }, 1000)
  }
  $("#total-elementor").addClass("hidden").css("display","none");
  $("#confirm_order").removeClass("hidden").css("display","block");
  $("#total_loader").removeClass("hidden");
  $(".wraper-form").addClass("hidden");
  $(".upload-text-checkout").removeClass("hidden");
  //$(".how-works").addClass("hidden");
 
  $("#total_loader").parent().css("position", "relative");
  $("#total_loader").removeClass("hidden").css("display", "block");
  $(this).find("span").text("Add To Cart");

  // Hide the loader and show the content after 1 second
  setTimeout(function() {
    
  //  $(".design__upload").parent().removeClass("hidden");
    //$(".how-works").removeClass("hidden").css({"display": "block","padding": "30px"});
    $(".design__upload").parent().show();
    $(".own_template").removeClass("hidden");
    $(".cart-price-wrapper").removeClass("hidden").css({"display": "block"});
    $(".price-details").removeClass("hidden");
    $(".optional-workflow-wrapper").removeClass("hidden");
      $("#confirm_order").removeClass("hidden").css("display", "block");
      $("#total_loader").addClass("hidden").css("display", "none");
  }, 2000); // 1000 milliseconds = 1 second
  

});

$(document).on('click', '.request_quote, .optional-workflow-section-close', function(e) {
  $(".product-variants").parent().show();  
  $(".wraper-form").addClass("hidden");
  $(".design__block__form").show();
  $("#total_loader").addClass("hidden");
  $(".dpo-container").removeClass("hidden");
  $("#total-elementor").addClass("hidden").css("display", "none");
  $("#confirm_order").addClass("hidden").css("display", "none");
  $("#confirm_order .optional-workflow-wrapper").addClass("hidden");
  $(".uploadkit-wrapper").parent().parent().removeClass('active-container');
  $(".upload-text-checkout").addClass("hidden");
  $(".cart-price-wrapper").addClass("hidden");
  $("#total_loader").parent().css("position", "relative");
  $("#total_loader").removeClass("hidden").css("display", "block");
  $("#quote-tab").removeClass("hide");
    if (window.UploadKit && typeof UploadKit.resetUploaders === 'function') UploadKit.resetUploaders();
    setTimeout(function() {
      $("#total_loader").addClass("hidden").css("display", "none");
      $(".wraper-form").removeClass("hidden");

    }, 2000); // 1000 milliseconds = 1 second
    if(window.mobileCheck()){
    
      $("html, body").animate({ scrollTop: $(".thumbnail-slider").offset().top + 100}, 1000)
   }
 
});
// Hide tabs 
 
$(document).on('click', '#tab-quote', function(e){
  $("#total-elementor").addClass("hidden").css("display", "none");
  //$(".how-works").addClass("hidden");
  $(".cart-price-wrapper").addClass("hidden");
  //$(".how-works").addClass("hidden");
  $(".variant-selects, .design__block__form").show();
  
});
$(document).on('click', '#tab-deals', function(e){
  $("#quote-tab").removeClass("hide");
  $("#total-elementor, #confirm_order").addClass("hidden").css("display", "none");
  //$(".how-works").addClass("hidden");
  $(".cart-price-wrapper").addClass("hidden");
  //$(".how-works").addClass("hidden");
  
});
//$(document).on('click', '.view_pp_templates', function(e){
  $(document).on('click', '.calculate-button', function(e){
       let $activeContainer = $(".active-container #upload__later");

    if ($activeContainer.length) {
        let upload_text = $activeContainer.text().trim();
        // console.log(upload_text);
        jQuery("#hidden_design_option").val(upload_text);
    }
     //$(".size-option select").trigger('change');
    // Total SQM
  // let width = parseFloat($("#hidden_property_standardized_width").val()) / 1000; // Convert mm to meters
  // let height = parseFloat($("#hidden_property_standardized_height").val()) / 1000; // Convert mm to meters
  // let quantity = parseInt($("input[name='quantity']").val());

  // if (isNaN(width) || isNaN(height) || isNaN(quantity) || width <= 0 || height <= 0 || quantity <= 0) {
  //     $("#hidden_property_standardized_sqm").val("Please enter valid positive numbers.");
  //     return;
  // }

  // let sqm = width * height * quantity;
  // $("#hidden_property_standardized_sqm").val( ".(" + sqm.toFixed(2) + ").");
// Convert width & height from mm to meters
let width = parseFloat($("#hidden_property_standardized_width").val()) / 1000;
let height = parseFloat($("#hidden_property_standardized_height").val()) / 1000;
let quantity = parseInt($("input[name='quantity']").val());
let productTitle = $("#hidden_producttitle").val();
let sheet_width = 0.95; // Fixed sheet width in meters
let sheet_height = 2.4; // Fixed sheet height in meters
let total_pieces = quantity; // Assuming quantity represents total pieces

if (isNaN(width) || isNaN(height) || isNaN(quantity) || width <= 0 || height <= 0 || quantity <= 0) {
   // $("#hidden_property_standardized_sqm").val("Please enter valid positive numbers.");
 //   $("#hidden_property_sheets_needed").val("0"); // Default to 0 sheets
  //  return;
}

// Calculate total sqm
let sqm = width * height * quantity;
$("#hidden_property_standardized_sqm").val(sqm.toFixed(2));
$("#hidden_property_product_title").val(productTitle + " (" + sqm.toFixed(2) + ")");
// Calculate how many pieces fit in one sheet
let piece_area = width * height;
let sheet_area = sheet_width * sheet_height;
let pieces_per_sheet = Math.floor(sheet_area / piece_area);

// Calculate total sheets needed (rounded up)
let sheets_needed = Math.ceil(total_pieces / pieces_per_sheet);
// Store total sheets needed in a hidden field
$("#hidden_property_sheets_needed").val(".(" + sheets_needed + ").");

    
    $("#pacdora-designs-section").removeClass("hide");
    let option_selected_text =  $(".option.clicked").find("b").text();
   
  $(".quote_btn .confirm_order").find("span").text("Next");
  // Hide various sections
  $("#upload_section.optional-workflow-wrapper").addClass("hidden");
  $(".wraper-form").addClass("hidden");
  $("#total-elementor").addClass("hidden").css("display", "none");
  //$(".dpo-container").addClass("hidden");
  $("#total_loader").parent().css("position", "relative");
  $("#total_loader").removeClass("hidden").css("display", "block");
  $(".product-variants").parent().hide();  
  $(".design__block__form").hide();
  $("#quote-tab").addClass("hide");

  // Show loader and then show content after 1 second
  setTimeout(function() {
    //$(".how-works").removeClass("hidden").css({"display": "block","padding": "30px"});
      $("#total-elementor").removeClass("hidden").css("display", "block");
      $("#total_loader").addClass("hidden").css("display", "none");
     $(".productbilldetail").text(option_selected_text);
      // Get and trim the content of #tprice
      let priceText = ($('#tprice').html() || '').trim();
    //  console.log('Raw price text:', priceText);
      
      // Remove any non-numeric characters except the decimal point
      var cleanPriceText = priceText.replace(/[^0-9.]/g, '');
     // console.log('Cleaned price text:', cleanPriceText);
      
      // Parse the cleaned text as a float
      let price = parseFloat(cleanPriceText);
      //console.log('Parsed price:', price);
      
      let deliveryTime = '';

      if (isNaN(price)) {
          deliveryTime = 'Please enter a valid number.';
      } else if (price < 0) {
          deliveryTime = 'Price cannot be negative.';
      } else if ((price < 500 && $("#option_val").val() === 'Yes')) {
        deliveryTime = '3 hours';
    } 
    else if (price < 1000) {
          deliveryTime = '24 hours';
      } else if (price <= 2000) {
          deliveryTime = '48 hours';
      } else if (price <= 3000) {
          deliveryTime = '72 hours';
      } else if (price <= 5000) {
          deliveryTime = '96 hours';
      } else {
          deliveryTime = '7 days';
      }
      
      // Check the value of the select element
      if($("#option_val").val() === 'No') {
          $('#delivery-time').removeClass("hidden");
      } else {
          $('#delivery-time').addClass("hidden");
      }
      
      // Set the delivery time
      $('#delivery-time').text(deliveryTime).removeClass("hidden");
      /* VIVID CRO: expose the production tier (it was computed then discarded) */
      window.__vqDispatchTier = deliveryTime;
      if(window.vividDispatchUpdate){ try{ window.vividDispatchUpdate(deliveryTime); }catch(e){} }
      //$(".how-works").removeClass("hidden");
      /* VIVID CRO: land at the START of the quote (#total-elementor). Other handlers scroll to the
         gallery/thumbnail-slider AFTER this, so we re-assert once they've finished (.stop cancels them). */
      var _vqUserScroll=false;var _vqOnUser=function(){_vqUserScroll=true;$("html, body").stop(true);};$(window).off(".vqgotop").on("wheel.vqgotop touchmove.vqgotop",_vqOnUser);var _vqGoTop=function(){if(_vqUserScroll){return;}var _t=$("#total-elementor");if(_t.length){$("html, body").stop(true).animate({scrollTop:_t.offset().top - 80},350);}};
      if(window.__vqSilentCalc){ window.__vqSilentCalc=false; }
      else { _vqUserScroll=false; _vqGoTop(); setTimeout(_vqGoTop, 1100); }
      /* flip the mobile sticky bar to Total + Buy Now now that a quote exists */
      window.__vqCalculated=true; if(window.vividStickyCalculated){window.vividStickyCalculated();}
  }, 1000); 

  // Update product mini detail
  updateProductMiniDetail();

  // Prevent default behavior
  e.preventDefault(true);

  // Set quantity input value if undefined or empty
  if($(".quantity__input").val() === undefined || $(".quantity__input").val() === "") {
      $(".quantity__input").val(1);
  }

  // Display the active section
  $('.activesection').removeClass('hide');
  $(this).addClass('clicked');

  // Scroll to the requiredesignstep
  //$("html, body").animate({ scrollTop: $(".requiredesignstep").offset().top - 5 }, 1000);
  //$("html, body").animate({ scrollTop: $(".optional-workflow-section.activesection").offset().top }, 1000);  
});

    $(document).on('click','.option-content-wrapper.design__upload', function(e){
    $(".uploadkit-wrapper").parent().removeClass('active-container');
    $(".optional-workflow-wrapper").removeAttr("style");
    //$('.uploadkit-wrapper').parent().parent().parent().parent().addClass('active-container');
    $(this).addClass('active-container');
    $("#skip_upload").removeClass("hide");
    $("#continue_cart").addClass("hide");
        let $activeContainer = $(".active-container #upload__later");
    if ($activeContainer.length) {
        let upload__later = $activeContainer.text().trim();
        //console.log(upload_text);
        jQuery("#hidden_design_option").val(upload__later);
    }
    if (window.UploadKit && typeof UploadKit.resetUploaders === 'function') UploadKit.resetUploaders();
  
  })
  window.UploadKit = window.UploadKit || {} 
  window.UploadKit.callbacks = window.UploadKit.callbacks || {} 
  window.UploadKit.callbacks.afterRefresh = function(data) {
    if(data.uploader.files.length > 0) {
      $(".optional-workflow-wrapper").css("padding-bottom", "30px");
     $(".uploadkit-wrapper").parent().addClass('active-container');
      //$('.uploadkit-wrapper').parent().parent().parent().parent().addClass('active-container');
      $("#upload--instructions").removeClass('active-container');
      $("#upload--instructions .design__upload span").removeClass('hide');
      $("#continue_cart").removeClass("hide");
      $("#skip_upload").addClass("hide");
        let $activeContainer = $(".active-container #design__upload__single");
      if ($activeContainer.length) {
          let upload_text2 = $activeContainer.text().trim();
          //console.log(upload_text);
          jQuery("#hidden_design_option").val(upload_text2);
      }
    }else{
     // console.log("not uploaded");
    }
     
  }

      
      if(pitchprint_catid!=undefined && pitchprint_catid!=""){
            if($("#hidden_meta_print_read_artwork_options").val().indexOf('own')!=-1){
               
        // console.log('category_id',pitchprint_catid);
          $(".pp-designs-wrapper .items").html("");
          let data = {
              "category_id":pitchprint_catid
          };  
          $.ajax({
              method: "POST",  
              url: "https://phpstack-321644-985620.cloudwaysapps.com/pitchprint-design.php", 
              data: data,
  
              success: function(result){                           
                  let data = JSON.parse(result);
                  let designs = data.data.items;
                if(designs !=undefined){
                  designs.sort(function (a, b) {
                      return a.title.localeCompare(b.title);
                  });
                  // console.log('designs:',designs.length);
                  (function(_o){var _n=0;(function _g(){var _$=window.jQuery;if(_$&&_$.fn&&typeof _$.fn.pagination==='function'){try{_$(".pp-designs-wrapper").pagination(_o);}catch(e){}}else if(_n++<60){setTimeout(_g,100);}})();})({
                      dataSource: designs,
                      pageSize: 3,
                      callback: function(data, pagination) {                        
                          var html = data;
                          $('.pp-designs-wrapper .items').html(html);
                          var title=  $("#productSelect option:selected").html();
                          data.forEach(function(d){
                              let previewImg = d.previews[0];
                              $(".pp-designs-wrapper .items").append('<div class="pitchprint_design" design-id="'+d.id+'"><div class="pp-design-overlay"></div><img src="'+previewImg+'" alt="'+title+'"/><a href="javascript:void(0)" class="customize_design">Customise</a><button id="resetDesignButton" class="hide">Reset Design</button></div>');
                          })                        
                      }
                  });
                  // $("img.lazyload").lazyload();    
                }
              }
          });  
            }
      }            

          
  
        
    
    $('.requiredesignstep .option:first-child').trigger('click');
  
//   let variations = product.variants;
  
//   let metafields = {};
//   variations.forEach(function(d,i){
//     if(i<=19){
//     let tmp = {};
//       let title = d.title;
//       tmp['width'] = title.includes("A0")?"841":(title.includes("A1")?"594":(title.includes("A2")?"420":"297"));
//     tmp['height'] = title.includes("A0")?"1188":(title.includes("A1")?"841":(title.includes("A2")?"594":"420"));
//     tmp['sided'] = "Single";
//     metafields[d['id']] = tmp;
//     }
//   });
//   console.log(product.id);
//   console.log(JSON.stringify(metafields));
// $(".admin__control-select").select2({
//   minimumResultsForSearch: Infinity
// });
// $(".select .select__select").select2({
//   minimumResultsForSearch: Infinity
// });

// $(document).on('click', '#hot-deals', function(e){
//   $("#total-elementor").addClass("hidden"); 

// });
// $(document).on('click', '#instant-quote', function(e){
//   $("#total-elementor").removeClass("hidden").css('display','none'); 
//   $("#quote-tab").removeClass("hidden"); 
//   $(".design__block__form").show().css('margin-bottom','25px');
//   $("variant-selects").show();
// });

//  Print Div

// $('#printQuote').on('click', function() {
//   var divContent = $('.receipts-wrapper').html();
//   var printWindow = window.open('', '_blank', 'height=400,width=600');
//   printWindow.document.write('<html><head><title>Print Quote</title>');
//   printWindow.document.write('</head><body >');
//   printWindow.document.write(divContent);
//   printWindow.document.write('</body></html>');
//   printWindow.document.close();
//   printWindow.print();
// });



// $(document).on('change', '.select-product-option select', function(e){
//   let selectedOption = $(this).find('option:selected').html();
//   if(selectedOption.includes('Yes')){
//  $("#upload--instructions").addClass('hidden');
//   }else{
//     $("#upload--instructions").removeClass('hidden');
//   }
// });
$(document).on('change', '.same-day-option select', function(e){
  //$('.same-day-option select').change(function(e) {
    // Log the event
    //console.log('Change event triggered');
    
    /* Shabbir's live fix (merged 4 Jun 2026): do nothing when no option is selected */
    const _vqOptHtml = $(this).find('option:selected').html();
    if (_vqOptHtml == null) return;
    let selectedOption = _vqOptHtml.trim();
   // console.log('Selected option:', selectedOption);
    $("#option_val").val(selectedOption);
      if(selectedOption.includes('Yes')){
   $("#design_assist").addClass('hidden').removeClass("clicked");
   //$("#design_exist").addClass("clicked");
   $("#design_exist").trigger("click");
   //$(".multiple").addClass('hidden');
   //$('body').find('.own_template').attr("id","same-day-option");
   //$('body').find('#same-day-option').hide();
   //$('body').find('#upload--instructions').hide();
    }else{
     $("#design_assist").removeClass('hidden clicked');
      $("#design_exist").addClass("clicked");
      //$(".multiple").addClass('hidden');
     // $('body').find('#same-day-option').show();
      //$('body').find('#upload--instructions').show();
      //$('body').find('#upload--instructions').show();
     // $(".own_template .option-content-wrapper").removeClass('hidden');
    }
   
  });

$(document).on('click','.price-details', function(e){  
  //console.log("sss");

  $("#total_loader").parent().css("position", "relative");
  $("#total_loader").removeClass("hidden").css("display", "block");
  $("#confirm_order").addClass("hidden").css("display", "none");
  $(".cart-price-wrapper").addClass("hidden");
  //$(".how-works").addClass("hidden");
  $("#quote-tab").addClass("hide");
  setTimeout(function() {
    if(window.mobileCheck()){
    $("html, body").animate({ scrollTop: $("#product-mini-detail-2").offset().top }, 1000); 
    //  $("html, body").animate({ scrollTop: $(".thumbnail-slider").offset().top + 100}, 1000)
   }
    $(".confirm_order").find("span").text("Next");
    $("#total-elementor").removeClass('hidden').css("display", "block");
    $("#total_loader").addClass("hidden").css("display", "none");
    $("#confirm_order").addClass("hidden").css("display", "none");
    //$(".how-works").removeClass("hidden");
    
  }, 2000); // 1000 milliseconds = 1 second
});

// Back to Details Code
$(document).on('click','.details-back', function(e){  
  $(".request_quote").trigger("click");
  $("#total_loader").parent().css("position", "relative");
  $("#total_loader").removeClass("hidden").css("display", "block");
  //$(".how-works").addClass("hidden");
  $("#quote-tab").addClass("hide");
  // Hide the loader and show the content after 1 second
  setTimeout(function() {
    if(window.mobileCheck()){
    
      $("html, body").animate({ scrollTop: $(".thumbnail-slider").offset().top + 100}, 1000)
   }
    $(".wraper-form").removeClass("hidden");
    $("#total_loader").addClass("hidden").css("display", "none");
    $("#quote-tab").removeClass("hide");
  }, 2000); // 1000 milliseconds = 1 second
  
  
});
// Begin ToolTips
   $(document).on('click','.lead-time .relative', function(e){
              $("#ProductionToolTip").modal('show');
             });
            
             $(document).on('click','.shipping .relative', function(e){
              $("#ShippingToolTip").modal('show');
             });
  
            $(document).on('click','.qty-lables .optionlabel', function(e){
               $("#QtyToolTip").modal('show');
              });
              $(document).on('click','.buy-more-section-wrapper .optionlabel #tool', function(e){
                $("#BulkQtyToolTip").modal('show');
               });
  
            $(document).on('click','.tool_tip .dpo_tooltip_icon', function(e){
             let tooltip = $(this).find('.dpo_tooltip_body').html();
             let heading = $(this).find('.dpo_tooltip_body h4').text();
             $(".tooltip-wrapper").html(tooltip);
             $("#LoadToolTip .modal-header strong").html(heading);
              $("#LoadToolTip").modal('show');
             });
  $(document).on('click','.multiple .upload-text-checkout .tool_tip', function(e){
  $("#letusdesign").modal('show');
 });
  $(document).on('click','#upload__later .tool_tip', function(e){
  $("#upload__later__modal").modal('show');
 });
$(document).on('click','#design__upload__single .tool_tip', function(e){
  $("#uploadonlyoneartwork").modal('show');
 });
  
$(document).on('click', '.price-btn-calculator', function (e) {
  var targetElement = $(".wraper-form.boxshadow, .calculatorqtyadjust");
   $("html, body").animate({ scrollTop: targetElement.offset().top + 0 }, 1000);
  $('#PriceTooltip').modal('hide');
});
$(document).on('click','#product-description-container .price_min', function(e){
  $("#PriceTooltip").modal('show');
 });

$(document).on('click','.lead-time .relative', function(e){
  $("#ProductionToolTip").modal('show');
 });

 $(document).on('click','.delivery b', function(e){
  $("#DeliveryToolTip").modal('show');
 });
 $(document).on('click','#pickup .tool_tip', function(e){
  $("#PickupToolTip").modal('show');
 });
 $(document).on('click','#design_exist .tool_tip', function(e){
  $("#DesignAssistToolTip").modal('show');
 });
 $(document).on('click','#design_own_option .tool_tip', function(e){
  $("#DesignServiceToolTip").modal('show');
 });
 $(document).on('click','#design_assist .tool_tip', function(e){
  $("#DesignToolTip").modal('show');
 });
 $(document).on('click','.shipping .relative', function(e){
  $("#ShippingToolTip").modal('show');
 });
 
 $(document).on('click','#delivery_required .tool_tip', function(e){
  $("#ShippingToolTip").modal('show');
 });
 
$(document).on('click','.product-form__quantity .form__label', function(e){
   $("#QtyToolTip").modal('show');
  });
  $(document).on('click','.continue--btn', function(e){
 //   alert("sss");
  });
  // Show the div on hover
//   $('.buy-more-section-wrapper').hover(
//     function() {
//         $('#buy-more-section-wrapper').show(); // Show the div
//         $(this).addClass('hovered');  // Add class on hover
//     },
//     function() {
//         $('#buy-more-section-wrapper').hide(); // Hide the div when not hovering
//         $(this).removeClass('hovered'); // Remove the hover class
//     }
// );

// Add a class on click
$('.itier_price').click(function() {
    $(this).addClass('clicked');
    if($(this).hasClass('clicked')){
      $(this).parent().parent().parent().hide();


    }
});
// Hide the section if clicking outside of it
$(document).on('click', function(e) {
  const container = $('#buy-more-section-wrapper');
  const button = $('#buy-more-button');

  // Check if the clicked element is not the container or the button
  if (!container.is(e.target) && container.has(e.target).length === 0 &&
      !button.is(e.target) && button.has(e.target).length === 0) {
    
    if (container.hasClass('is-visible')) {
      container.removeClass('is-visible').slideUp();
    }
  }
});
$(document).on('click','#buy-more-button', function(e){
    const target = $('#buy-more-section-wrapper');
    $('#buy-more-section-wrapper').removeAttr('style');

   target.addClass('is-visible');
       
    
});

 if ($('body').hasClass('design_exist')) {
  $(document).on('click','#upload_now_container', function(e){
    
  // Remove any previous message
  $(this).addClass('active-container');
  $("#upload--instructions").removeClass('active-container');
  $('#tickcheck .temp-message').remove();
  // Create a temporary message
  let message = $('<span class="temp-message text-black checkout_text">Choose a File. Step 2: Upload It to Activate This Option.</span>');

  // Append it to the element
  //$(this).after(message);

  // Auto-remove after 1 second
  // setTimeout(function() {
  //   message.fadeOut(1000, function() {
  //     $(this).remove();
  //   });
  // }, 2000);
});
}
 

$(document).on('click','.delivery-process .option', function(e){
  e.preventDefault(true);    
  $(this).siblings().removeClass('clicked');
  $(this).addClass('clicked');
  // console.log($(this).text());
  $("#shipping_value").val($(this).text().trim());
 
});
$(".qty-wrapper").insertBefore("variant-selects");
 

jQuery(document).on('change', '.width input', function() {
  // Trim leading zeros
  let value = parseInt($(this).val(), 10); // Converts to a number, discards leading zeros
  if (value >= 30) {
      $(this).removeClass('valid-value');
      $(this).val(value); // Update input with trimmed value
      jQuery('.popular input:checked').prop('checked', false);
      jQuery('li.width input').val(value);
  } else {
      $(this).addClass('valid-value');
      $(this).val(0);
      var errMessage = '<span class="error-msg">Please enter a value greater than or equal to 30</span>';
      $('.width').append(errMessage);
      setTimeout(function() {
          $('.width .error-msg').remove();
          $('.width input').removeClass('valid-value');
      }, 2000);
  }
});

jQuery(document).on('change', '.height input', function() {
  // Trim leading zeros
  let value = parseInt($(this).val(), 10); // Converts to a number, discards leading zeros
  if (value >= 30) {
      $(this).removeClass('valid-value');
      $(this).val(value); // Update input with trimmed value
      jQuery('.popular input:checked').prop('checked', false);
      jQuery('li.height input').val(value);
  } else {
      $(this).addClass('valid-value');
      $(this).val(0);
      var errMessage = '<span class="error-msg">Please enter a value greater than or equal to 30</span>';
      $('.height').append(errMessage);
      setTimeout(function() {
          $('.height .error-msg').remove();
          $('.height input').removeClass('valid-value');
      }, 2000);
  }
});

 // Select the radio input inside the assist option and get its "price" attribute
 let assistPrice = $('.admin__field-option.assist input').attr('price');
 /* 24-Aug bug #101: on native buy-flow products ITORIS DPO does not load, this element
    does not exist, and assistPrice is undefined — writing it blanked the server-rendered
    fee ("$undefined per design" → the placeholder 0 customers saw). Only overwrite when
    the DPO element is really there. */
 if (assistPrice != null) jQuery("#design_charges_dpo").text(assistPrice);

// Tier Discount Prices
  function updateButtonState() {
    jQuery(".quantity__input").each(function() {
        var $input = jQuery(this);
        var minQty = parseFloat($input.attr('tp-min-qty')) || 0;
        var currentVal = parseFloat($input.val()) || 0;

        var $button = $input.siblings(".quantity__button[name='minus']");
        if (currentVal <= minQty) {
            $button.prop("disabled", true);
            $(this).val(minQty);
        } else {
            $button.prop("disabled", false);
        }
    });
}

 
updateButtonState();

// Run when input value changes
jQuery(".quantity__input").on("input change", function() {
    updateButtonState();
    
});


QtyUpdate();
//UpdateTierPricesOnVariantChange();
});

 
function QtyUpdate() {
  const $menu = $('#tiered-options');
  const $display = $('#PDPQty .selected-text');
  const $display2 = $('#PDPQty #selected-text');
  const $qtyInput = $('input[name="quantity"]');
  const $customWrapper = $('#custom-qty-wrapper');
  const $customQty = $('#custom-qty');
  const $customTotal = $('#custom-total-price');

  let isCustomActive = false;
  let currentQty = parseInt($qtyInput.val(), 10) || 1;

  function buildTieredOptions() {
    $menu.empty();
    $('.itier_price').each(function () {
      const qty = $(this).attr('qty');
      const price = $(this).attr('price');
      const discount = $(this).attr('discount');
      let label = `${qty} | ($${parseFloat(price).toFixed(2)}/unit)`;
      if (discount) label += ` – Save ${discount}%`;
      $menu.append(`<li data-qty="${qty}" data-price="${price}">${label}</li>`);
    });
    $menu.append(`<li class="custom-option">Custom Quantity…</li>`);
  }

  function getBestTier(qty) {
    let bestMatch = null;
    let bestQty = 0;
    $('.itier_price').each(function () {
      const tierQty = parseInt($(this).attr('qty'), 10);
      if (tierQty <= qty && tierQty > bestQty) {
        bestMatch = $(this);
        bestQty = tierQty;
      }
    });
    return bestMatch;
  }

  function updateDisplay(qty, price) {
    $display.text(`${qty} | $${price.toFixed(2)}/unit`);
    $display2.html(`<span id="editable-qty" contenteditable="true" class="blink-cursor">${qty}</span> | $${price.toFixed(2)}/unit`).removeClass('blinking-line');
    $qtyInput.val(qty).trigger('change');
    currentQty = qty;
  }

  function resetToBestTier() {
    const match = getBestTier(currentQty);
    if (match) {
      const price = parseFloat(match.attr('price'));
      updateDisplay(currentQty, price);
    } else {
      const first = $('.itier_price').first();
      if (first.length) {
        const qty = parseInt(first.attr('qty'));
        const price = parseFloat(first.attr('price'));
        updateDisplay(qty, price);
      }
    }
  }

  function handleCustomQtyInput(qty) {
    if (isNaN(qty) || qty <= 0) {
      $customTotal.text('').addClass('hidden');
      resetToBestTier();
      $customQty.val('');
      return;
    }
    const match = getBestTier(qty);
    const unitPrice = match ? parseFloat(match.attr('price')) : 0;
    const total = qty * unitPrice;

    updateDisplay(qty, unitPrice);
    $customTotal.text(`$${total.toFixed(2)} total`).removeClass('hidden');
    $customQty.val(qty);
  }

  buildTieredOptions();
  resetToBestTier();

  // Toggle dropdown
  $(document).off('click.dropdownToggle').on('click.dropdownToggle', '#PDPQty', function (e) {
    e.stopPropagation();
    if (!isCustomActive) $menu.toggle();
  });

  // Handle tier/custom click
  $menu.off('click.optionSelect').on('click.optionSelect', 'li', function (e) {
    e.stopPropagation();
    const $li = $(this);
    $menu.find('li').removeClass('selected');
    $li.addClass('selected');
    $menu.hide();

    if ($li.hasClass('custom-option')) {
      isCustomActive = true;
      $menu.hide();
      $customWrapper.show().find('input').val(currentQty).focus();
      $(".qty_flow").hide();
      handleCustomQtyInput(currentQty);
    } else {
      isCustomActive = false;
      const qty = parseInt($li.data('qty'), 10);
      const price = parseFloat($li.data('price'));
      $customWrapper.hide();
      $customTotal.addClass('hidden');
      $(".qty_flow").show();
      updateDisplay(qty, price);
    }
  });

  // Live input on custom quantity field
  $customQty.off('input').on('input', function () {
    const qty = parseInt($(this).val().replace(/[^\d]/g, ''), 10);
    handleCustomQtyInput(qty);
  });

  // Content editable inline quantity
  $(document).off('input.editQty').on('input.editQty', '#editable-qty', function () {
    const qty = parseInt($(this).text().replace(/[^\d]/g, ''), 10);
    handleCustomQtyInput(qty);
  });

  // Handle backspace in custom field
  $customQty.off('keydown').on('keydown', function (e) {
    if (e.key === 'Backspace') {
      e.preventDefault();
      $customQty.val('');
      $customTotal.text('').addClass('hidden');
      $display.text('');
      $display2.text('').addClass('blinking-line');
      $qtyInput.val('');
    }
  });

  // Cancel custom
  $('#cancel-custom').off('click.cancelCustom').on('click.cancelCustom', function (e) {
    e.preventDefault();
    isCustomActive = false;
    $customWrapper.hide();
    $(".qty_flow").show();
    $customTotal.addClass('hidden');
    $customQty.val('');
    resetToBestTier();
  });

  // Close on outside click
  $(document).off('click.outsideClose').on('click.outsideClose', function (e) {
    if (!$(e.target).closest('.acedisplay-dropdown-wrapper').length) {
      $menu.hide();
    }
    if (($display2.html() || '').trim() === '') {
      resetToBestTier();
    }
  });
}

// Call this after variant change
function UpdateTierPricesOnVariantChange() {
  QtyUpdate();
}

// Watch for variant change
$(document).off('change.variantSelector').on('change.variantSelector', '.single-option-selector', function () {
  setTimeout(UpdateTierPricesOnVariantChange, 50);
});

// Initial call on page load
$(document).ready(function () {
  QtyUpdate();
  
});



window.addEventListener('load', function () {
  document.querySelectorAll('.es-review-avatar img').forEach(function(img) {
    // Move src to data-src
    if (img.getAttribute('src')) {
      img.setAttribute('data-src', img.getAttribute('src'));
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      img.classList.add('lazyload');
      img.setAttribute('width', '40');
      img.setAttribute('height', '40');
    }
  });
    document.querySelectorAll('.eapp-photo-gallery-item-data-imageContainer img').forEach(function(img) {
    // Move src to data-src
    if (img.getAttribute('src')) {
      img.setAttribute('data-src', img.getAttribute('src'));
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      img.classList.add('lazyload');
    }
  });
    document.querySelectorAll('.jeQkYp img').forEach(function(img) {
    // Move src to data-src
    if (img.getAttribute('src')) {
      img.setAttribute('data-src', img.getAttribute('src'));
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      img.classList.add('lazyload');
    }
  });
  document.querySelectorAll('.pitchprint_design img').forEach(function(img) {
  
  var title = img.getAttribute('title') || '';

  // Move src to data-src
  if (img.getAttribute('src')) {
    img.setAttribute('data-src', img.getAttribute('src'));
    img.removeAttribute('src');
    img.removeAttribute('srcset');
    img.classList.add('lazy2');
    img.classList.add('lazyload');
  }

  // Set alt attribute using title (if present)
  if (title) {
    img.setAttribute('alt', title);
  }
});
    
});






/* Vivid Ads CRO: mobile sticky price+buy bar init (runs from product.js so the theme optimizer does not defer it) */
(function(){
  function vividStickyInit(){
    var bar=document.getElementById('vivid-sticky-atc');
    if(!bar||bar.classList.contains('is-ready'))return;
    var priceEl=document.getElementById('totalPrice');
    var out=document.getElementById('vivid-sticky-price');
    if(!out)return;
    function sync(){ if(!window.__vqCalculated)return; var t=priceEl?(priceEl.textContent||'').trim():''; if(t)out.textContent=t; }
    window.vividStickyCalculated=function(){
      window.__vqCalculated=true;
      document.body.classList.add('vq-calc-done');
      var lbl=bar.querySelector('.vivid-sticky-atc__label'); if(lbl)lbl.textContent=document.body.classList.contains('vq-step2')?'Ready to order':'Total estimate';
      var b2=document.getElementById('vivid-sticky-buy'); if(b2)b2.textContent=document.body.classList.contains('vq-step2')?'Buy Now':'Continue';
      sync();
    };
    if(priceEl){ try{new MutationObserver(sync).observe(priceEl,{childList:true,subtree:true,characterData:true});}catch(e){} }
    bar.classList.add('is-ready');bar.setAttribute('aria-hidden','false');document.body.classList.add('vivid-has-sticky');
    function vqToast(msg){
      var t=document.querySelector('.vq-toast');
      if(!t){ t=document.createElement('div'); t.className='vq-toast'; document.body.appendChild(t); }
      t.textContent=msg; t.classList.add('show');
      clearTimeout(t.__h); t.__h=setTimeout(function(){ t.classList.remove('show'); }, 3200);
    }
    var b=document.getElementById('vivid-sticky-buy');
    if(b){b.addEventListener('click',function(){
      if(b.classList.contains('vq-loading')) return; /* no double-tap / double-add */
      function vqLoading(){
        b.classList.add('vq-loading');
        if(!b.getAttribute('data-vq-label')) b.setAttribute('data-vq-label', b.textContent);
        b.textContent='Adding…';
        var done=function(){ clearInterval(iv); clearTimeout(to); b.classList.remove('vq-loading'); b.textContent=b.getAttribute('data-vq-label')||'Buy Now'; b.removeAttribute('data-vq-label'); };
        var iv=setInterval(function(){
          var open=document.querySelector('#slidecarthq .slidecarthq');
          if(open && open.offsetParent!==null){ done(); }
        }, 400);
        var to=setTimeout(done, 12000);
      }
      /* step-aware action: artwork step → first WORKING buy path; totals visible → Continue; else calculate */
      if(document.body.classList.contains('vq-step2')){
        var cands=['#skip_upload','#continue_cart','.but-flex-layout .quote_btn .confirm_order','#AddToCart:not(.hide)','button[name="add"]'];
        for(var c=0;c<cands.length;c++){
          var el=document.querySelector(cands[c]);
          if(el && el.offsetParent!==null && !el.disabled){ vqLoading(); el.click(); return; }
        }
        /* CRO mobile fix (25 Jun): the inline add buttons are hidden by the redesign, so the
           visible-only proxy above finds nothing and bails. Fall back to the ACTIVE (non-.hide)
           add button even when it is not 'visible', so the sticky Buy Now still triggers the real
           add (add_to_cart() then opens the slide cart). */
        var vqAlt=['#continue_cart','#skip_upload','.but-flex-layout .quote_btn .confirm_order','#AddToCart','button[name="add"]'];
        for(var va=0;va<vqAlt.length;va++){
          var ae=document.querySelector(vqAlt[va]);
          if(ae && !ae.disabled && !ae.classList.contains('hide') && !ae.classList.contains('hidden')){ vqLoading(); ae.click(); return; }
        }
        vqToast('Choose an artwork option above to continue');
        var art=document.querySelector('.requiredesignstep, .vq-artcard, #upload_section');
        if(art){ var ya=art.getBoundingClientRect().top+window.pageYOffset-90; window.scrollTo({top:ya<0?0:ya,behavior:'smooth'}); }
        return;
      } else if(window.__vqCalculated){
        var cont=document.querySelector('.but-flex-layout .quote_btn .confirm_order');
        if(cont&&cont.offsetParent!==null){ cont.click(); return; }
      } else {
        /* "See total": run the calculation if the configuration is complete; otherwise highlight what's missing */
        var fsels=[].slice.call(document.querySelectorAll('.product-variants select, #quote-tab select')).filter(function(s){ return s.offsetParent!==null; });
        var missing=null;
        for(var j=0;j<fsels.length;j++){
          var s=fsels[j], o=s.options[s.selectedIndex];
          if(!s.value || /^(select|choose|pick|--)/i.test(((o&&o.text)||'').trim())){ missing=s; break; }
        }
        if(missing){
          missing.classList.add('vq-field-missing');
          (function(m){ setTimeout(function(){ m.classList.remove('vq-field-missing'); }, 2600); })(missing);
          vqToast('Choose an option to see your total');
          var ym=missing.getBoundingClientRect().top+window.pageYOffset-120;
          window.scrollTo({top:ym<0?0:ym,behavior:'smooth'});
          return;
        }
        var calc=document.querySelector('.calculate-button');
        if(calc && calc.offsetParent!==null){ calc.click(); return; }
      }
      var sels=window.__vqCalculated?['#AddToCart:not(.hide)','.calculate-button','button[name="add"]','#totalPrice']:['.product-variants','#PDPQty','.requiredesignstep','.calculate-button'];
      for(var i=0;i<sels.length;i++){var t=document.querySelector(sels[i]);if(t&&t.offsetParent!==null){var y=t.getBoundingClientRect().top+window.pageYOffset-70;window.scrollTo({top:y<0?0:y,behavior:'smooth'});return;}}
    });}
  }
  vividStickyInit();setTimeout(vividStickyInit,600);setTimeout(vividStickyInit,1800);
  if(window.jQuery){try{jQuery(document).on('change','select',function(){setTimeout(vividStickyInit,50);});}catch(e){}}
})();


/* Vivid Ads CRO: design-option highlight fix — ensure the .clicked highlight follows the user's actual choice
   (the AI Design Studio widget was re-asserting .clicked on the first card; the hidden value already updates correctly). */
(function(){
  if(!window.jQuery) return;
  jQuery(document).on('click', '.requiredesignstep .option', function(){
    var el = this;
    var reassert = function(){
      var group = el.parentElement; if(!group) return;
      group.querySelectorAll(':scope > .option').forEach(function(o){ o.classList.remove('clicked'); });
      el.classList.add('clicked');
    };
    reassert();
    setTimeout(reassert, 60);
    setTimeout(reassert, 200);
  });
})();

/* sentinel: legacy product wiring (jQuery handlers) is bound */
window.__vqProductJs = 1;


/* vivid ATC-DEDUPE v2 (15 Jun): enforce a SINGLE visible Add-To-Cart button across
   BOTH submit-design flows (Upload my files + Expert designer) and every DPO template.
   v1 only reacted to class/style changes on the buttons themselves, so the Expert-designer
   step (revealed via an ancestor container) was missed and left two buttons visible.
   v2 also watches container/childList changes + a light poll. It collapses ONLY when
   itoris has marked exactly ONE of the visible buttons as the live add (the [dpo_add2cart]
   attribute); when that is ambiguous it does nothing, so it can never hide a button the
   current step actually needs. Pure visibility: never touches the add request or redirects. */
(function(){
  var SEL='#skip_upload,#continue_cart,#quote_to_cart_btn';
  function visAdd(){
    return [].slice.call(document.querySelectorAll(SEL)).filter(function(b){
      if(b.offsetParent===null) return false;                 // not rendered / hidden ancestor
      var st=(b.getAttribute('style')||'');
      if(/display\s*:\s*none|visibility\s*:\s*hidden/i.test(st)) return false; // inline-hidden phantom
      return true;
    });
  }
  function enforce(){
    var v=visAdd();
    if(v.length<2) return;                                     // single button = normal, leave it
    var keepers=v.filter(function(b){ return b.hasAttribute('dpo_add2cart'); });
    if(keepers.length!==1) return;                            // ambiguous -> hands off (safe)
    var keep=keepers[0];
    v.forEach(function(b){ if(b!==keep){ try{ b.classList.add('hide'); }catch(e){} } });
  }
  var pending=false;
  function schedule(){ if(pending) return; pending=true; setTimeout(function(){ pending=false; enforce(); },50); }
  function boot(){
    try{
      new MutationObserver(schedule).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','dpo_add2cart']});
    }catch(e){}
    try{ setInterval(enforce,600); }catch(e){}                // backstop for anything the observer misses
    enforce();
  }
  if(document.body){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
